/**
 * Name     :   Raj Janorkar
 * Date     :   23 May 14
 * Desc     :   Main Config Javascript File.
 */

const __BASEURL = 'https://igtab.com/'; // TODO: change it to production
const __SHINDIG_RPC = '/shindig/rpc' // TODO: change it to production based if not sub-folder then '/shindig/rpc'
var __indef // undefined
// gadget types
const __TYPE_INTERNAL = 'Internal' // Internal
const __TYPE_OPEN_SOCIAL = 'Open Social' // Open Social
const __TYPE_FEED = 'RSS' // Feed
// feeds
const __FEED_NO_ENTRIES = [3, 5, 7, 10, 15, 20, 25] // Feed Number of Entries to Display
const __FEED_DEFAULT_ENTRIES = 5 // No. of default entries to display for feed gadget
const __FEED_DEFAULT_DISPLAY = 'Detailed' // Detailed feed display
const __FEED_DISPLAY_STYLE = ['List', 'Detailed', 'No Images', 'News Paper'] // Feed display style
const __FEED_DISPLAY_LIST = 'List' // Feed List
const __FEED_DISPLAY_DETAILED = 'Detailed' // Feed detailed
const __FEED_DISPLAY_NEWS_PAPER = 'News Paper' // Feed News Paper
const __FEED_DISPLAY_NO_IMAGES = 'No Images' // Feed No Images
// constants
const __ADMIN = 'admin' // Account Type ADMIN
const __HOME = 'home' // Home view
const __CANVAS = 'canvas' // Canvas
const __GADGET = 'gadget' // Gadget
const __YES = 'yes' // yes
const __NO = 'no' // no

const __GADGET_LOAD_AND_DISPLAY = 'L' // Load and display gadget
const __GADGET_EDIT_PREF = 'E' // Gadget edit preferences
// tabs
const __TAB_TITLE_LENGTH = 21 // Tab title length for drop drown menu
const __TAB_ICON_UPLOAD_DIR = 'images/icon/' // Tab image upload image directory
const __TAB_TEMPLATE_VALUE = [4, 3, 2, 1] // if this is changed then all the places including controller code needs to be changed.
const __TAB_TEMPLATE_NAME = ['Four Columns', 'Three Columns', 'Two Columns', 'One Column'] // Add New Tab Display Option
const __TAB_DEFAULT_TEMPLATE = 3 // Default Tab Template while adding new tab
// http response code
const __HTTP_VALIDATION_FAILED = 422 // Laravel validation failed
const __HTTP_BAD_REQUEST = 400 // Bad Request
const __HTTP_UNAUTHORIZED = 401 // Unauthorized : Authentication credentials for the target resource.
const __HTTP_TOKEN_MISMATCH = 419 // The page has expired due to inactivity.

// Apache Shindig Container setup
var __shindig_loaded = false
if (window.shindig && window.gadgets) {
    __shindig_loaded = true
}
if (__shindig_loaded) {
    var config = config || {}
    config[osapi.container.ContainerConfig.RENDER_DEBUG] = false // change it to false in production
    //  config[osapi.container.ServiceConfig.API_HOST] = window.location.origin;
    config[osapi.container.ServiceConfig.API_PATH] = __SHINDIG_RPC
    var CommonContainer = new osapi.container.Container(config)
    CommonContainer.EnablePreferences = true
}

/*------------------------------------------------------------------------------------------------*\
 * Class    :   $app
 * Desc     :   Portal Main Application Loader
 \*-----------------------------------------------------------------------------------------------*/

let $app = {
    /*------------------------------------------------------------------------------------------------*\
     * Local objects/variables for $app object
     \*-----------------------------------------------------------------------------------------------*/
    _user: {
        lang: 'en',
        active_tab: null,
        logged: false,
        tab_loaded: {}
    },
    _gadget: {},
    _tab: {},
    _gen: {
        gadgetLoading: __BASEURL + 'images/loading-small.gif',
        gadget_max_height: 2048,
        gadget_min_height: 350,
        gadget_min_auto_height: 150,
        rss: 'RSS',
        gadget: 'GADGET',
        default_view: 'default',
        tab_order: []
    },

    /**
     * $app.init : Initialise and load portal
     * @param isLogged - is user logged in
     * @param lang - en
     */
    init: function (lang, isLogged) {
        this._user.lang = lang
        this._user.logged = (isLogged === __indef) ? false : isLogged

        if (__shindig_loaded) {
            // initialise apache shindig
            $app.shindig.init()
        }

        // load user tabs & display portal header
        $app.tab.load()

        // show user announcements if there are any
        $app.user.showAnnouncements()
    },

    /**
     * Set user logged in or not based on server level auth::check
     * @param isLogged
     */
    userLoggedIn: function (isLogged) {
        this._user.logged = (isLogged === __indef) ? false : isLogged
    },

    /*------------------------------------------------------------------------------------------------*\
     * Class    :   $app.tab
     * Desc     :   App tab related functions
     \*-----------------------------------------------------------------------------------------------*/
    tab: {
        /*
         * $app.tab.load : Load user's all available tabs & then call function to display header
         * Params   : None
         * Returns  : None
         */
        load: function () {
            // Get all tabs for current user from DB
            $.ajax({
                url: '/api/tabs',
                type: 'GET',
                dataType: 'json',
                cache: false,
                async: true
            })
              .done(function (response) {
                  $.each(response.data, function (index, tab) {
                      $app._tab[tab.id] = {
                          title: tab.title,
                          template: tab.template,
                          theme_id: tab.theme_id,
                          active: tab.is_selected,
                          icon: tab.icon
                      }

                      $app._gen.tab_order.push(tab.id)

                      // set default tab if it is not set
                      if ($app._user.active_tab === null || $app._user.active_tab === 0 || tab.is_selected === 1) {
                          $app._user.active_tab = tab.id
                      }
                  })

                  // Check for valid tab id in tabs present for user.
                  if ($app._tab[$app._user.active_tab] === __indef) {
                      // get the first tab id as default tab to load
                      $app._user.active_tab = _.head($app._gen.tab_order)
                  }
                  // load all gadgets for each tab for current user
                  $app.gadget.load($app._user.active_tab)
                  // display tab menu
                  $app.header.displayTabMenu()
                  // load theme
                  $app.theme.apply($app._tab[$app._user.active_tab].theme_id)
              })
              .fail(function (jqXHR, textStatus, errorThrown) {
                  $app.gen.commonFailResponseMessage(jqXHR)
              })
        },

        /*
         * $app.tab.loadTemplate : Load template based on tab id
         * Params   : tab_id - tab id
         * Returns  : None
         */
        loadTemplate: function (tab_id) {
            let template = $app._tab[tab_id].template
            let l_s = ''
            let widgetGrid = $('#widget-grid')
            // @formatter:off
            switch (template) {
                case 1 :
                    l_s += '<div class="row" id="' + tab_id + '">'
                                + '<div class="col-sm-12 col-md-12 col-lg-12 sortable-grid" id="col-1-' + tab_id + '"></div>'
                        + '</div>'
                    widgetGrid.append(l_s)
                    break
                case 2 :
                    l_s += '<div class="row" id="' + tab_id + '">'
                              + '<div class="col-sm-6 col-md-6 col-lg-6 sortable-grid" id="col-1-' + tab_id + '"></div>'
                              + '<div class="col-sm-6 col-md-6 col-lg-6 sortable-grid" id="col-2-' + tab_id + '"></div>'
                        + '</div>'
                    widgetGrid.append(l_s)
                    break
                case 3 :
                    l_s += '<div class="row" id="' + tab_id + '">'
                              + '<div class="col-sm-6 col-md-4 col-lg-4 sortable-grid" id="col-1-' + tab_id + '"></div>'
                              + '<div class="col-sm-6 col-md-4 col-lg-4 sortable-grid" id="col-2-' + tab_id + '"></div>'
                              + '<div class="col-sm-6 col-md-4 col-lg-4 sortable-grid" id="col-3-' + tab_id + '"></div>'
                        + '</div>'
                    widgetGrid.append(l_s)
                    break
                case 4 :
                    l_s += '<div class="row" id="' + tab_id + '">'
                              + '<div class="col-sm-6 col-md-4 col-lg-3 sortable-grid" id="col-1-' + tab_id + '"></div>'
                              + '<div class="col-sm-6 col-md-4 col-lg-3 sortable-grid" id="col-2-' + tab_id + '"></div>'
                              + '<div class="col-sm-6 col-md-4 col-lg-3 sortable-grid" id="col-3-' + tab_id + '"></div>'
                              + '<div class="col-sm-6 col-md-4 col-lg-3 sortable-grid" id="col-4-' + tab_id + '"></div>'
                        + '</div>'
                    widgetGrid.append(l_s)
                    break
                case 11 : // Testing Template to show preview HOME
                    l_s += '<div class="row mt-4" id="' + tab_id + '">'
                            + '<div class="col-sm-12 col-md-4 offset-md-4 offset-lg-4 col-lg-4 sortable-grid" id="col-1-' + tab_id + '"></div>'
                          + '</div>'
                    widgetGrid.append(l_s)
                    break
                case 12 : // Testing Template to show preview CANVAS
                    l_s += '<div class="row mt-4" id="' + tab_id + '">'
                            + '<div class="col-sm-12 col-md-12 col-lg-12 sortable-grid" id="col-1-' + tab_id + '"></div>'
                        + '</div>'
                    widgetGrid.append(l_s)
                    break
                case 13 : // Testing Template to show gadget detail preview
                    l_s += '<div class="sortable-grid" id="col-1-' + tab_id + '"></div>'
                    widgetGrid.append(l_s)
                    break
            }
            // @formatter:on
        },

        /**
         * $app.tab.reload : Reload tab and it's gadgets if there is template change, or gadget/feed added to tab
         * @param tab_id - tab id
         */
        reload: function (tab_id) {
            $('.row#' + tab_id + '').remove() // remove whole tab loaded dom
            $app._user.tab_loaded[tab_id] = 0 // mark tab never loaded before

            // remove all the gadgets for given tab
            $.each($app._gadget, function (key, value) {
                if ($app._gadget[key].tab_id === tab_id) {
                    _.unset($app._gadget, key)
                }
            })

            $app.tab.redirect(tab_id)
        },

        /*
         * $app.tab.setActiveTab : Add gadget to tab
         * Params   : tab_id - Tab ID
         * Returns  : None
         */
        setActiveTab: function (tab_id) {
            // get required details for current user
            $.ajax({
                url: '/api/tabs/active',
                data: { tab_id: tab_id },
                type: 'PATCH',
                dataType: 'json',
                cache: false,
                async: true
            })
              .done(function (response) {
                  // $app.gen.commonDoneResponseMessage(response);
              })
              .fail(function (jqXHR, textStatus, errorThrown) {
                  // $app.gen.commonFailResponseMessage(jqXHR);
              })
        },

        /*
         * $app.tab.redirect : redirect to different tab
         * Params   : tab_id - tab id to redirect to
         * Returns  : None
         */
        redirect: function (tab_id) {
            let cur_tab = $app._user.active_tab
            // hide active tab
            $('.row#' + cur_tab + '').hide()
            $app._user.active_tab = tab_id // set new tab as active tab
            $('#tab_active').empty() // remove selected tab
            $('#tab_menu').empty() // remove drop down menu
            // redisplay tab menu
            $app.header.displayTabMenu()
            if ($app._user.tab_loaded[tab_id] !== 1) { // tab is not loaded previously
                $app.gadget.load($app._user.active_tab)
            } else {
                $('.row#' + $app._user.active_tab + '').show() // display requested tab
                // bind jquery/jqueryUI event to page
                $app.jq.init()
            }
            // load theme
            $app.theme.apply($app._tab[$app._user.active_tab].theme_id)

            // update user active tab
            $app.tab.setActiveTab(tab_id)
        },

        /*
         * $app.tab.emptyTabMessage : show add gadgets or feeds to the tab message
         * Params   : tab_id - tab id to append the message
         * Returns  : None
         */
        emptyTabMessage: function (tab_id) {
            if (tab_id === __indef) {
                tab_id = $app._user.active_tab
            }

            // show add gadgets or feeds to the tab message
            // @formatter:off
            let l_s = '<div class="col-12 text-center mt-2 mb-4 no-gadgets-msg">'
                        + '<h4>There are no gadgets to show in this tab, Please add your favourite gadgets from directory.</h4>'
                        + '<a href="' + __BASEURL + 'directory/gadgets' + '" type="button" class="btn btn-success font-weight-bold font-family-nunito mt-2 mr-2"><i class="fas fa-fw fa-th-large mr-1"></i>Add Gadgets</a>'
                        + '<a href="#" onclick="$app.tab.addRss(); return false;" class="btn btn-primary font-weight-bold font-family-nunito mt-2" target="_blank"><i class="fas fa-fw fa-rss mr-1"></i>Add RSS Feed</a>'
                    +'</div>';
            // @formatter:on

            $('.row#' + tab_id + '').append(l_s)
        },

        /*
         * $app.tab.addGadget : Add gadget to tab
         * Params   : gadget_id - Gadget ID
         *          : tab_id - Tab ID
         *          : js_obj - current js object used for disabling button
         * Returns  : None
         */
        addGadget: function (gadget_id, tab_id, js_obj) {
            if (tab_id === __indef) {
                tab_id = null
            }

            // Add given gadget to the tab
            $.ajax({
                url: '/api/tabs/gadgets',
                data: { tab_id: tab_id, gadget_id: gadget_id },
                type: 'POST',
                dataType: 'json',
                cache: false,
                async: true
            })
              .done(function (response) {
                  $app.gen.commonDoneResponseMessage(response)
                  $(js_obj).prop('disabled', true).html('Added')
              })
              .fail(function (jqXHR, textStatus, errorThrown) {
                  $app.gen.commonFailResponseMessage(jqXHR)
              })
        },

        /*
         * $app.tab.addRss : Add RSS gadget to tab
         * Params   : need_auth - 1 - display authentication else not
         *          : feed_url - Feed URL
         * Returns  : None
         */
        addRss: function (feed_url, need_auth) {
            // hide bootbox model
            bootbox.hideAll()

            if (need_auth === __indef) {
                need_auth = ''
            }

            let successLabel = 'Add Feed'
            if ($app._user.logged === false) {
                toastr['error']('Please login to add rss feeds to your tab.')
                return
            }

            // @formatter:off
            let l_s = '<form id="formAddRSS" action="">'
                + '<div class="form-group">'
                    + '<label for="feedURL">RSS feed URL</label>'
                        if (feed_url) {
                            l_s += '<input type="text" class="form-control" id="feedURL" value="' + feed_url + '">';
                        } else {
                            l_s += '<input type="text" class="form-control" id="feedURL" placeholder="Enter RSS feed or website URL">';
                        }
                l_s += '</div>';

            if (need_auth) {
                l_s += '<div class="form-group">'
                        + '<label for="login">Feed User Name</label>'
                        + '<input type="text" class="form-control" id="login" placeholder="RSS feed user name">'
                    + '</div>'
                    + '<div class="form-group">'
                        + '<label for="password">Feed Password</label>'
                        + '<input type="password" class="form-control" id="password" placeholder="RSS feed password">'
                    + '</div>';
            }
            l_s += '</form>';
            // @formatter:on

            // Display Form for edit preferences
            bootbox.dialog({
                title: 'Add RSS Feed',
                message: l_s,
                buttons: {
                    danger: {
                        label: '<i class="fas fa-arrow-left mr-2"></i>Cancel',
                        className: 'btn-sm btn-light font-family-nunito font-weight-bold',
                    },
                    success: {
                        label: '<i class="fas fa-rss mr-2"></i>' + successLabel,
                        className: 'btn-sm btn-success font-family-nunito font-weight-bold btn-submit',
                        callback: function () {
                            let feed_auth = __indef
                            let $formAddRSS = $('#formAddRSS')
                            let feed_URL = $.trim($formAddRSS.find('input#feedURL').val())
                            let login = $formAddRSS.find('input#login').val()
                            let password = $formAddRSS.find('input#password').val()

                            if (feed_URL !== '') {
                                $app.gen.buttonLoading('btn-submit', true) // show loading on button
                                // check for valid feed.
                                // get user name and password for feed
                                if (login !== __indef && password !== __indef) {
                                    feed_auth = $app.Base64.encode(login + ':' + password)
                                }
                                // check feed is valid or not
                                $app.feed.checkFeed(feed_URL, feed_auth)
                            } else {
                                // Display error message stating not entered correct feed url
                                toastr['error']('Please enter correct RSS feed or website URL.')
                            }
                            // keep model open
                            return false
                        }
                    }
                }
            })
        },

        /*
         * $app.tab.saveTheme : Save theme for user/tab in DB
         * Params   : theme_id - Theme ID to save
         *          : tab_id - Tab ID
         *          : js_obj - current js object used for disabling button
         * Returns  : None
         */
        saveTheme: function (theme_id, tab_id, js_obj) {
            if (tab_id === __indef) {
                tab_id = null
            }

            if (theme_id === __indef) {
                theme_id = null
            }

            // apply theme to currently active tab
            $.ajax({
                url: '/api/tabs/theme',
                data: { tab_id: tab_id, theme_id: theme_id },
                type: 'PATCH',
                dataType: 'json',
                cache: false,
                async: true
            })
              .done(function (response) {
                  $app.gen.commonDoneResponseMessage(response)
                  $(js_obj).prop('disabled', true).html('Applied')
              })
              .fail(function (jqXHR, textStatus, errorThrown) {
                  $app.gen.commonFailResponseMessage(jqXHR)
              })
        },

        /*
         * $app.tab.changeTabImage : Select image for the tab
         * Params   : tab_id - Tab id to change the image icon
         * Returns  : None
         */
        changeTabImage: function (tab_id) {
            // display image upload form
            // @formatter:off
            let l_s = '<div class="row">'
                        + '<div class="col-10 offset-1 col-sm-10 offset-sm-1 col-md-10 offset-md-1 mt-4">'
                            + '<ul class="list-inline">'
                                + '<li class="list-inline-item mb-1"><a onclick=\'$app.tab.selectIcon(' + tab_id + '); return false; \' href="#">No icon</a></li>'
                                    for (let i = 0; i <= 80; i++) {
                                        l_s += '<li class="list-inline-item mb-1" role="button"><img onclick=\'$app.tab.selectIcon(' + tab_id + ',' + i + '); return false; \' src="' + __BASEURL + __TAB_ICON_UPLOAD_DIR + i + '.gif"></li>'
                                    }
                        l_s += '</ul>'
                        + '</div>'
                    + '</div>'
            // @formatter:on

            bootbox.dialog({
                className: 'changeTabImage',
                message: l_s,
                title: 'Tab Icon',
                buttons: {
                    danger: {
                        label: '<i class="fas fa-arrow-left mr-2"></i>Cancel',
                        className: 'btn-sm btn-light font-family-nunito font-weight-bold',
                    }
                }
            })
        },

        /*
         * $app.tab.selectIcon : Save tab icon to tab table
         * Params   : tab_id - Tab id to change the image icon
         *          : tabIcon - Tab icon number
         * Returns  : None
         */
        selectIcon: function (tab_id, tabIcon) {
            if (tabIcon === __indef) {
                tabIcon = ''
            } else {
                tabIcon = tabIcon + '.gif'
            }
            // set active tab icon
            $app._tab[tab_id].icon = tabIcon

            // save add icon to tab
            $.ajax({
                url: '/api/tabs/icon',
                data: { tab_id: tab_id, tab_icon: tabIcon },
                type: 'PATCH',
                dataType: 'json',
                cache: false,
                async: true
            })
              .done(function (response) {
                  let tab_id = _.has(response, 'tab_id') ? response.tab_id : null
                  let tab_icon = _.has(response, 'tab_icon') ? response.tab_icon : null
                  $app.gen.commonDoneResponseMessage(response)
                  if (tab_id) {
                      // assign new image to tab icon
                      $app._tab[tab_id].icon = tab_icon
                      // hide all current active bootbox
                      bootbox.hideAll()
                      // Display tab's option with new images
                      $app.tab.options()
                      // Display tab menu with new images
                      $app.header.displayTabMenu()
                  }
              })
              .fail(function (jqXHR, textStatus, errorThrown) {
                  $app.gen.commonFailResponseMessage(jqXHR)
              })
        },

        /*
         * $app.tab.edit : Edit tabs name and template
         * Params   : tab_id - tab id to edit setting
         * Returns  : None
         */
        edit: function (tab_id) {
            let successLabel = 'Update'
            // @formatter:off
            let l_s = '<form id="formTabDetails" action="">'
                            + '<div class="form-group">'
                                + '<label for="tab_title">Tab Name</label>'
                                + '<input type="text" class="form-control" value="' + $app._tab[tab_id].title + '" id="tab_title" name="tab_title">'
                            + '</div>'
                            + '<div class="form-group">'
                                + '<label for="tab_template">Tab Layout</label>'
                                + '<select class="form-control selectpicker" data-container="body" id="tab_template">';
                                        for (var i = 0; i < __TAB_TEMPLATE_VALUE.length; i++) {
                                            if (__TAB_TEMPLATE_VALUE[i] == $app._tab[tab_id].template) {
                                                l_s += '<option value="' + __TAB_TEMPLATE_VALUE[i] + '" selected>' + __TAB_TEMPLATE_NAME[i] + '</option>';
                                            } else {
                                                l_s += '<option value="' + __TAB_TEMPLATE_VALUE[i] + '">' + __TAB_TEMPLATE_NAME[i] + '</option>';
                                            }
                                        }
                            l_s += '</select>'
                            + '</div>'
                        + '</form>';
            // @formatter:on

            bootbox.dialog({
                title: 'Change Tab Details',
                message: l_s,
                buttons: {
                    danger: {
                        label: '<i class="fas fa-arrow-left mr-2"></i>Cancel',
                        className: 'btn-sm btn-light font-family-nunito font-weight-bold',
                    },
                    success: {
                        label: '<i class="fas fa-save mr-2"></i>' + successLabel,
                        className: 'btn-sm btn-success font-family-nunito font-weight-bold btn-submit',
                        callback: function () {
                            // get the new values from form
                            let tab_title = $('input#tab_title').val()
                            let tab_template = $('select#tab_template option:selected').val()
                            $app.gen.buttonLoading('btn-submit', true) // show loading on button

                            // change name
                            let ajax_name = $.ajax({
                                url: '/api/tabs/name',
                                data: { tab_id: tab_id, tab_title: tab_title },
                                type: 'PATCH',
                                dataType: 'json',
                                cache: false,
                                async: true
                            })

                            // change template
                            let ajax_template = $.ajax({
                                url: '/api/tabs/template',
                                data: { tab_id: tab_id, tab_template: tab_template },
                                type: 'PATCH',
                                dataType: 'json',
                                cache: false,
                                async: true
                            })

                            // Use $.when to check if both AJAX calls are successful
                            $.when(ajax_name, ajax_template)
                              .done(function (name, template) {
                                  let tab_id = _.has(name[0], 'tab_id') ? _.parseInt(name[0].tab_id) : null
                                  let tab_title = _.has(name[0], 'tab_title') ? name[0].tab_title : null
                                  if (tab_id) {
                                      // change the tab details
                                      $app._tab[tab_id].title = tab_title
                                  }

                                  tab_id = _.has(template[0], 'tab_id') ? _.parseInt(template[0].tab_id) : null
                                  let tab_template = _.has(template[0], 'tab_template') ? _.parseInt(template[0].tab_template) : null
                                  let hasChangedTemplate = false
                                  if (tab_id && $app._tab[tab_id].template !== tab_template) {
                                      // change the tab details
                                      $app._tab[tab_id].template = tab_template
                                      hasChangedTemplate = true
                                  }

                                  // [data, textStatus, jqXHR]
                                  // e.g. To access returned data, access the array at index 0
                                  // console.log(name[0]);
                                  // console.log(template[0]);
                                  $app.gen.commonDoneResponseMessage(name[0])
                                  $app.gen.commonDoneResponseMessage(template[0])
                                  // hide all current bootbox models
                                  bootbox.hideAll()
                                  if (hasChangedTemplate && $app._user.active_tab == tab_id) {
                                      // redirect to new tab
                                      $app.tab.reload(tab_id)
                                  } else {
                                      // Display tab menu with new names
                                      $app.header.displayTabMenu()
                                  }
                                  // Display tab's option with new images
                                  $app.tab.options()
                              })
                              .fail(function (jqXHR, textStatus, errorThrown) {
                                  $app.gen.buttonLoading('btn-submit', false, successLabel) // hide loading on button
                                  $app.gen.commonFailResponseMessage(jqXHR)
                              })

                            // keep modal open
                            return false
                        }
                    }
                },
                onShown: function (e) {
                    $app.jq.bootstrapSelect()
                },
            })
        },

        /*
         * $app.tab.options : Tabs setting/options
         * Params   : None
         * Returns  : None
         */
        options: function () {
            if ($app._user.logged === false) {
                toastr['error']('Please Login to access Tab Options.')
                return
            }

            // @formatter:off
            let l_s = '<div class="row">'
                        + '<div class="col-sm-10 offset-sm-1 mb-2">'
                        + '<div class="tab-options">'
                            + '<ul class="tab-list">'
                                $.each($app._gen.tab_order, function (index, value) {
                                    var tab_icon = ($app._tab[value].icon) ? $app._tab[value].icon : '0.gif'
                                    var tab_title = $app.gen.truncate($app._tab[value].title, __TAB_TITLE_LENGTH, '...')
                                    l_s += '<li id="' + value + '">'
                                                + '<span class="tab-handle" data-toggle="popover" data-content="Reorder your tabs by dragging and dropping.">'
                                                    + '<i class="fas fa-arrows-alt text-success mr-1"></i>'
                                                + '</span>'
                                                + '<a href="#" onclick=\'$app.tab.changeTabImage(' + value + '); return false; \' data-toggle="popover" data-content="Change tab icon.">'
                                                + ((tab_icon && tab_icon !== '0.gif') ? '<img src="' + __BASEURL + __TAB_ICON_UPLOAD_DIR + tab_icon + '">' : '<i class="fas fa-fw fa-image mr-1"></i>')
                                                + '</a>'
                                                + '<span class="text">' + tab_title + '</span>'
                                                + '<div class="tools">'
                                                    + '<a href="#" onclick=\'$app.tab.edit(' + value + '); return false; \' data-toggle="popover" data-content="Change tab name and column layout.">'
                                                        + '<i class="fas fa-pencil-alt text-success"></i>'
                                                    + '</a>'
                                                + '</div>'
                                        + '</li>'
                                })
                        l_s += '</ul>'
                        + '</div>'
                    + '</div>'
                + '</div>'
            // @formatter:on

            bootbox.dialog({
                message: l_s,
                title: 'Change Tabs Settings',
                buttons: {
                    danger: {
                        label: '<i class="fas fa-check mr-2"></i>Done',
                        className: 'btn-sm btn-success font-family-nunito font-weight-bold',
                    }
                },
                onShown: function (e) {
                    $app.jq.firePopovers()
                },
            })

            // Enable sortable
            $app.jq.tabsSortable()
        },

        /*
         * $app.tab.saveTabOrder : Save new tab's order in database
         * Params   : positionArr - New postion array
         * Returns  : None
         */
        saveTabOrder: function (positionArr) {
            // save new position to database
            $.ajax({
                url: '/api/tabs/order',
                data: { position: positionArr },
                type: 'PATCH',
                dataType: 'json',
                cache: false,
                async: true
            })
              .done(function (response) {
                  $app.gen.commonDoneResponseMessage(response)
                  // change the original array ordering
                  $app._gen.tab_order = positionArr.slice()
              })
              .fail(function (jqXHR, textStatus, errorThrown) {
                  $app.gen.commonFailResponseMessage(jqXHR)
              })
        }
    },

    /*------------------------------------------------------------------------------------------------*\
     * Class    :   $app.theme
     * Desc     :   Themes related functions
     \*-----------------------------------------------------------------------------------------------*/
    theme: {
        theme_loaded: {},
        /*
         * $app.theme.load : load all themes from Database and display it
         * Returns  : None
         */
        load: function () {},

        /*
         * $app.theme.apply - Apply theme to the current tab.
         * Params   : theme_id : Theme ID from DB to apply
         * Returns  : None
         */
        apply: function (theme_id) {
            if (theme_id === __indef) {
                theme_id = $app._tab[$app._user.active_tab].theme_id
            }

            // check theme is already loaded or not
            if (this.theme_loaded[theme_id] == 1) {
                $app.theme.setActiveTheme(theme_id)
            } else {
                let loadCSS = __BASEURL + 'directory/themes/get-tab-theme?theme_id=' + theme_id + '&tab_id=' + $app._user.active_tab
                if ($app.theme.setActiveTheme(theme_id) == false) {
                    //load the stylesheet in head section as alternative stylesheet.
                    $app.theme.addCssFile(loadCSS, theme_id, 'alternate stylesheet')
                    //activate the stylesheet.
                    $app.theme.setActiveTheme(theme_id)
                    this.theme_loaded[theme_id] = 1
                }
            }
        },

        /*
         * $app.theme.addCssFile : add CSS to page header
         * Params   : theme_id - Theme ID from DB to apply
         *          : loadCSS - URL of css
         *          : rel = alternate stylesheet
         * Returns  : None
         */
        addCssFile: function (loadCSS, theme_id, rel) {
            $('<link/>', {
                href: loadCSS,
                rel: rel == __indef ? 'stylesheet' : rel,
                title: theme_id == __indef ? 'css' : theme_id,
                type: 'text/css'
            }).appendTo('head')
        },
        /*
         * $app.theme.setActiveTheme : Activate a stylesheet
         * Params   : theme_id - Theme ID from DB to apply
         * Returns  : None
         */
        setActiveTheme: function (theme_id) {
            let applied = false
            $('link[rel*=alternate][title]').each(function (i) {
                this.disabled = true
                if (this.getAttribute('title') == theme_id) {
                    this.disabled = false
                    applied = true
                }
            })
            return applied
        },

        /*
         * $app.theme.displaySubmitForm : Display Theme submit form
         * Params   : None
         * Returns  : None
         */
        displaySubmitForm: function () {
            // @formatter:off
            let l_s = '<div class="row">'
                        + '<div class="col-sm-10 offset-sm-1 col-md-8 offset-md-2 mt-2">'
                            + '<form id="formSubmitTheme" action="">'
                                + '<div class="form-group">'
                                    + '<div class="col-sm-12">'
                                        + '<input type="text" class="form-control" placeholder="Enter your theme xml URL" id="themeURL" name="themeURL" autofocus>'
                                    + '</div>'
                                + '</div>'
                                + '<div class="form-group">'
                                    + '<div class="col-sm-12 text-center">'
                                        + '<button type="submit" onclick=\'$app.theme.submitTheme(); return false; \' id="btnSubmitTheme" class="btn btn-success btn-submit font-weight-bold font-family-nunito">Submit Theme</button>'
                                    + '</div>'
                                + '</div>'
                            + '</form>'
                        + '</div>'
                    + '<div class="col-sm-12 col-md-10 offset-md-1 mt-2">'
                        + '<blockquote class="blockquote">'
                            + '<p>Please make sure theme has below <strong>Meta Name</strong> in <strong>ConfigMap</strong>. Don\'t submit <strong>Test Theme</strong> it will not be approved by admin.</p>'
                        + '</blockquote>'

                        + '<dl class="row mt-4">'
                            + '<dt class="col-sm-4">title</dt>'
                            + '<dd class="col-sm-8">Title displayed in the Themes directory.</dd>'

                            + '<dt class="col-sm-4">description</dt>'
                            + '<dd class="col-sm-8">Describes the theme.Description of the theme and what it does. </dd>'

                            + '<dt class="col-sm-4">author</dt>'
                            + '<dd class="col-sm-8">Author\’s name shown in the Themes directory. </dd>'

                            + '<dt class="col-sm-4">author_email</dt>'
                            + '<dd class="col-sm-8">The theme author\'s email address. </dd>'

                            + '<dt class="col-sm-4">screenshot</dt>'
                            + '<dd class="col-sm-8">URL of a theme screenshot. </dd>'

                            + '<dt class="col-sm-4">thumbnail</dt>'
                            + '<dd class="col-sm-8">URL of a theme thumbnail. </dd>'

                            + '<dt class="col-sm-4">full_page_thumbnail.url</dt>'
                            + '<dd class="col-sm-8">Thumbnails are used in the themes directory to give users a preview of a theme. </dd>'
                        + '</dl>'
                    + '</div>'
                + '</div>';
            // @formatter:on

            // Display theme submit form
            $('#submit-form').empty().append(l_s)
        },

        /*
         * $app.theme.submitTheme : Submit theme to directory
         * Params   : url - Theme URL
         * Returns  : None
         */
        submitTheme: function (url) {
            $app.gen.buttonLoading('btn-submit', true) // show loading on button
            let theme_url = $('input#themeURL').val()
            if (!$app.gen.ishttp(theme_url)) {
                theme_url = 'http://' + theme_url
            }

            // save theme to directory
            $.ajax({
                url: '/directory/themes/submit',
                data: { theme_url: theme_url },
                type: 'POST',
                dataType: 'json',
                cache: false,
                async: true
            })
              .done(function (response) {
                  let theme_id = _.has(response, 'theme_id') ? _.parseInt(response.theme_id) : null
                  $app.gen.commonDoneResponseMessage(response)

                  if (theme_id) {
                      // @formatter:off
                        let l_s = '<div class="row">'
                                    + '<div class="col-sm-10 offset-sm-1 col-md-8 offset-md-2 mt-2">'
                                        + '<blockquote class="blockquote">'
                                            + '<p>Congratulations! your theme is submitted successfully. Please note it may take few days to appear in the directory.</p>'
                                        + '</blockquote>'
                                        + '<div class="text-center mt-4">'
                                            + '<button type="button" onclick=\'$app.tab.saveTheme(' + theme_id + ',' + $app._user.active_tab + ', this); return false; \' id="btnAddTheme" class="btn btn-success font-weight-bold font-family-nunito mr-2">Apply to Current Tab</button>'
                                            + '<button type="button" onclick=\'$app.theme.displaySubmitForm(); return false; \' id="btnSubmitMore" class="btn btn-primary font-weight-bold font-family-nunito">Submit Another Theme</button>'
                                        + '</div>'
                                    + '</div>'
                                + '</div>';
                        // @formatter:on

                      $('#submit-form').empty().append(l_s)
                  } else {
                      toastr['error']('Oops! Something went wrong, please try again.')
                      $app.gen.buttonLoading('btn-submit', false, 'Submit Theme') // hide loading on button
                  }
              })
              .fail(function (jqXHR, textStatus, errorThrown) {
                  $app.gen.buttonLoading('btn-submit', false, 'Submit Theme') // hide loading on button
                  $app.gen.commonFailResponseMessage(jqXHR)
              });
        }

    },

    /*------------------------------------------------------------------------------------------------*\
     * Class    :   $app.gadget
     * Desc     :   App gadget related functions
     \*-----------------------------------------------------------------------------------------------*/
    gadget: {
        /*
         * $app.gadget.load : Load user's all available gadgets for each tab & then call function to display gadgets
         * Params   :
         *      tab_id - active tab id
         * Returns  : None
         */
        load: function (tab_id) {
            if (tab_id === __indef) {
                tab_id = $app._user.active_tab
            }

            // load template for tab
            $app.tab.loadTemplate(tab_id)

            // Get all gadgets from DB for tab
            // get required details for current user
            $.ajax({
                url: '/api/tabs/gadgets',
                data: { tab_id: tab_id },
                type: 'GET',
                dataType: 'json',
                cache: false,
                async: true,
            })
              .done(function (response) {
                  // mark this tab is loaded successfully.
                  $app._user.tab_loaded[tab_id] = 1

                  if (response.data.length === 0) {
                      $('#portalLoading').empty() // Remove loading
                      $app.tab.emptyTabMessage(tab_id) // show empty tab message to add gadgets/feeds
                  } else {
                      $.each(response.data, function (index, gadget) {
                          // key to store all gadgets
                          let key = tab_id + '-' + gadget.unique_id
                          $app._gadget[key] = {
                              tab_id: tab_id,
                              uniq_id: gadget.unique_id,
                              posx: gadget.posx,
                              posy: gadget.posy,
                              module_id: gadget.gadget_id,
                              feed_id: gadget.feed_id,
                              title: gadget.title,
                              variables: gadget.variables,
                              type: gadget.type,
                              style: gadget.colour_style,
                              feed_entries: gadget.feed_articles_count,
                              feed_display: gadget.feed_display_style,
                              need_auth: gadget.feed_need_auth,
                              feed_auth: gadget.feed_auth,
                              minimised: gadget.is_minimised,
                              autorefresh: gadget.auto_refresh,
                              url: gadget.url,
                              icon: gadget.icon,
                              height: gadget.height,
                              gstatus: gadget.status,
                              lang: gadget.language,
                              website: gadget.website,
                              thumb: gadget.thumbnail
                          }
                      })
                      $('#portalLoading').empty() // Remove loading
                      $app.gadget.displayAll(tab_id) // display all gadgets in tab
                      $app.jq.init() // bind jquery/jqueryUI event to page
                  }
              })
              .fail(function (jqXHR, textStatus, errorThrown) {
                  $app.gen.commonFailResponseMessage(jqXHR)
              })
        },

        /*
         * $app.gadget.displayAll : Display one by one all gadget in tab
         * Params   : tab_id - Active Tab ID
         * Returns  : None
         */
        displayAll: function (tab_id) {
            if (tab_id === __indef) {
                tab_id = $app._user.active_tab
            }
            // create all gadget template first
            $.each($app._gadget, function (key, value) {
                if ($app._gadget[key].tab_id === tab_id) {
                    $app.gadget.loadTemplate(key)
                }
            })
            //  load gadget content this has been separated from above because there is issue where content is not displayed in gadget
            $.each($app._gadget, function (key, value) {
                if ($app._gadget[key].tab_id === tab_id) {
                    $app.gadget.loadContent(key)
                }
            })
        },

        /*
         * $app.gadget.loadTemplate : Load gadget template
         * Params   : key - uniq key [tab_id + '-' + uniq_id] to identify which gadget to display.
         * Returns  : None
         */
        loadTemplate: function (key) {
            // @formatter:off
            let aboutButton = ''
            if ($app._gadget[key].type === __TYPE_OPEN_SOCIAL) {
                aboutButton = '<a href="' + __BASEURL + 'directory/gadgets/' + $app._gadget[key].module_id + '" class="jarviswidget-about-btn"><i class="fas fa-th-large text-success mr-2"></i>About this Gadget</a>'
            } else {
                aboutButton = '<a href="' + __BASEURL + 'directory/feeds/' + $app._gadget[key].feed_id + '" class="jarviswidget-about-btn"><i class="fas fa-rss text-danger mr-2"></i>About this RSS Feed</a>'
            }
            let column = '#col-' + $app._gadget[key].posx + '-' + $app._gadget[key].tab_id
            // All buttons
            let deleteButton = '<a href="javascript:void(0);" class="jarviswidget-delete-btn"><i class="fas fa-trash-alt text-danger mr-2"></i>Remove Gadget</a>'
            let settingButton = '<a href="javascript:void(0);" class="jarviswidget-edit-btn"><i class="fas fa-cog text-primary mr-2"></i>Edit Setting</a>'
            // let embedButton = '<a href="#" onclick=\'$app.gadget.embedGadget("' + key + '"); return false; \' class="jarviswidget-embed-btn"><i class="fas fa-clone text-success mr-2"></i>Embed this Gadget</a>';
            let contactButton = '<a href="#" onclick=\'$app.gadget.contactDeveloper("' + key + '"); return false; \' class="jarviswidget-contact-btn"><i class="fas fa-envelope text-success mr-2"></i>Contact Developer</a>'
            let sourceButton = '<a target="_blank" href="' + $app._gadget[key].url + '" class="jarviswidget-source-btn"><i class="fas fa-code text-primary mr-2"></i>View Source</a>'
            let flagButton = '<a href="#" onclick=\'$app.gadget.flagGadget("' + key + '"); return false; \' class="jarviswidget-flag-btn"><i class="fas fa-flag text-danger mr-2"></i>Report this Gadget</a>'
            let bttonGroup = '<div class="btn-group" id="gadgetOptions">'
                    + '<a  href="#" class="btn button-icon jarviswidget-option-btn" data-toggle="dropdown"><i class="fas fa-ellipsis-v"></i></a>'
                    + '<ul class="dropdown-menu dropdown-menu-right pull-right" role="menu">'
                        + '<li>' + settingButton + '</li>'
                        + '<li>' + deleteButton + '</li>'
                        + '<li>' + aboutButton + '</li>'
                        // + (($app._gadget[key].type == __TYPE_OPEN_SOCIAL) ? '<li>' + embedButton + '</li>' : '')
                        + '<li>' + sourceButton + '</li>'
                        + '<li>' + contactButton + '</li>'
                        + '<li>' + flagButton + '</li>'
                    + '</ul>'
                + '</div>'
            let fullScreenButton = '<a href="javascript:void(0);" class="button-icon jarviswidget-fullscreen-btn" rel="tooltip" title="Fullscreen" data-placement="bottom"><i class="fas fa-expand "></i></a>'
            let toggleButton = '<a href="#" class="button-icon jarviswidget-toggle-btn" rel="tooltip" title="Collapse" data-placement="bottom">'
                + (($app._gadget[key].minimised == 0)
                    ? '<i class="fas fa-minus">'
                    : '<i class="fas fa-plus">')
                + '</i></a>'
            let refreshButton = '<a href="#" class="button-icon jarviswidget-refresh-btn" data-loading-text="  Loading... " rel="tooltip" title="Refresh" data-placement="bottom"><i class="fas fa-sync"></i></a>'
            let colorButton = '<a data-toggle="dropdown" class="color-box selector" href="javascript:void(0);"></a><ul class="dropdown-menu dropdown-menu-right arrow-box-up-right color-select pull-right"><li><span class="bg-color-green" data-widget-setstyle="jarviswidget-color-green" rel="tooltip" data-placement="left" data-original-title="Green Grass"></span></li><li><span class="bg-color-greenDark" data-widget-setstyle="jarviswidget-color-greenDark" rel="tooltip" data-placement="top" data-original-title="Dark Green"></span></li><li><span class="bg-color-greenLight" data-widget-setstyle="jarviswidget-color-greenLight" rel="tooltip" data-placement="top" data-original-title="Light Green"></span></li><li><span class="bg-color-purple" data-widget-setstyle="jarviswidget-color-purple" rel="tooltip" data-placement="top" data-original-title="Purple"></span></li><li><span class="bg-color-magenta" data-widget-setstyle="jarviswidget-color-magenta" rel="tooltip" data-placement="top" data-original-title="Magenta"></span></li><li><span class="bg-color-pink" data-widget-setstyle="jarviswidget-color-pink" rel="tooltip" data-placement="right" data-original-title="Pink"></span></li><li><span class="bg-color-pinkDark" data-widget-setstyle="jarviswidget-color-pinkDark" rel="tooltip" data-placement="left" data-original-title="Fade Pink"></span></li><li><span class="bg-color-blueLight" data-widget-setstyle="jarviswidget-color-blueLight" rel="tooltip" data-placement="top" data-original-title="Light Blue"></span></li><li><span class="bg-color-teal" data-widget-setstyle="jarviswidget-color-teal" rel="tooltip" data-placement="top" data-original-title="Teal"></span></li><li><span class="bg-color-blue" data-widget-setstyle="jarviswidget-color-blue" rel="tooltip" data-placement="top" data-original-title="Ocean Blue"></span></li><li><span class="bg-color-blueDark" data-widget-setstyle="jarviswidget-color-blueDark" rel="tooltip" data-placement="top" data-original-title="Night Sky"></span></li><li><span class="bg-color-darken" data-widget-setstyle="jarviswidget-color-darken" rel="tooltip" data-placement="right" data-original-title="Night"></span></li><li><span class="bg-color-yellow" data-widget-setstyle="jarviswidget-color-yellow" rel="tooltip" data-placement="left" data-original-title="Day Light"></span></li><li><span class="bg-color-orange" data-widget-setstyle="jarviswidget-color-orange" rel="tooltip" data-placement="bottom" data-original-title="Orange"></span></li><li><span class="bg-color-orangeDark" data-widget-setstyle="jarviswidget-color-orangeDark" rel="tooltip" data-placement="bottom" data-original-title="Dark Orange"></span></li><li><span class="bg-color-red" data-widget-setstyle="jarviswidget-color-red" rel="tooltip" data-placement="bottom" data-original-title="Red Rose"></span></li><li><span class="bg-color-redLight" data-widget-setstyle="jarviswidget-color-redLight" rel="tooltip" data-placement="bottom" data-original-title="Light Red"></span></li><li><span class="bg-color-white" data-widget-setstyle="jarviswidget-color-white" rel="tooltip" data-placement="right" data-original-title="Purity"></span></li><li><a href="javascript:void(0);" class="jarviswidget-remove-colors" data-widget-setstyle="" rel="tooltip" data-placement="bottom" data-original-title="Reset widget color to default">Remove</a></li></ul>'

            // Create Module Template
            let l_s = ''
            if ($app._gadget[key].minimised == 0) {
                if ($app._gadget[key].style) {
                    l_s += '<div class="jarviswidget jarviswidget-sortable jarviswidget-color-' + $app._gadget[key].style + '" id="wid-id-' + key + '" role="widget" data-widget-attstyle="jarviswidget-color-' + $app._gadget[key].style + '">'
                } else {
                    l_s += '<div class="jarviswidget jarviswidget-sortable" id="wid-id-' + key + '" role="widget">'
                }
            } else {
                if ($app._gadget[key].style) {
                    l_s += '<div class="jarviswidget jarviswidget-sortable jarviswidget-color-' + $app._gadget[key].style + ' jarviswidget-collapsed" id="wid-id-' + key + '" role="widget" data-widget-attstyle="jarviswidget-color-' + $app._gadget[key].style + '">'
                } else {
                    l_s += '<div class="jarviswidget jarviswidget-sortable jarviswidget-collapsed" id="wid-id-' + key + '" role="widget">'
                }
            }
            l_s += '<header role="heading">'
                    + '<div class="jarviswidget-ctrls" style="display:none;" role="menu">'
                        + toggleButton + refreshButton + fullScreenButton + bttonGroup
                    + '</div>'
                    + '<div class="widget-toolbar" style="display:none;" role="menu">' + colorButton + '</div>'
                    + '<h2>'
                        + (($app._gadget[key].icon)
                            ? '<img class="moduleIcon mr-2 rounded" src="' + $app._gadget[key].icon + '">'
                            : '')
                        + '<span id="gadgetTitle">' + $app._gadget[key].title + '</span>'
                    + '</h2>'
                + '</header>'
                + (($app._gadget[key].minimised == 0) ? '<div style="display: block;" role="content">' : '<div style="display: none;" role="content">')
                        + '<div class="widget-body" id="gadget-site-' + key + '">'
                            + '<p class="text-center mt-4"><i class="fas fa-circle-notch fa-spin text-secondary fa-3x fa-fw"></i></p>'
                        + '</div>'
                    + '</div>'
                + '</div>'
            // @formatter:on

            // Display Module
            $(column).append(l_s)
        },

        /*
         * $app.gadget.loadContent : Load gadget content
         * Params   : key - uniq key [tab_id + '-' + uniq_id] to identify which gadget to display.
         *      view - default/home/canvas/preview
         * Returns  : None
         */
        loadContent: function (key, view) {
            if (view == __indef) {
                view = $app._gen.default_view
            }
            // Load feed
            if ($app._gadget[key].type == __TYPE_FEED) {
                $app.feed.loadFeed(key, view)
            } else { // Load other modules
                if ($app._gadget[key].type == __TYPE_OPEN_SOCIAL) {
                    if (__shindig_loaded) {
                        // Load Open Social gadget
                        $app.shindig.loadGadget(key, view, __GADGET_LOAD_AND_DISPLAY)
                    }
                } else {
                    $app.gadget.loadInternal(key) // Internal modules
                }
            }
        },

        /*
         * $app.gadget.loadInternal : Load internal gadget content
         * Params   : key - uniq key [tab_id + '-' + uniq_id] to identify which gadget to display.
         *      view - default/home/canvas/preview
         * Returns  : None
         */
        loadInternal: function (key) {
            // show loading gadget
            $app.gadget.loading(key)
        },

        /*
         * $app.gadget.loading : show gadget loading content
         * Params   : key - uniq key [tab_id + '-' + uniq_id] to identify which gadget to display.
         * Returns  : None
         */
        loading: function (key) {
            let gadget_id = '#wid-id-' + key
            let l_s = '<p class="text-center mt-4"><img src="' + $app._gen.gadgetLoading + '" alt="Loading..."></p>'
            // Display Loading
            $(gadget_id).find('.widget-body').empty()
            $(gadget_id).find('.widget-body').append(l_s)
        },

        /*
         * $app.gadget.preView : Display gadget in gadget detail page while user want to add it to tab.
         * Params   : type - I/F/O - Internal/Feed/Opensocial
         *          : gadget_title - title of the gadget preview
         *          : gadget_url - gadget url to render
         *          : feed_id - if RSS gadget then feed_id
         * Returns  : None
         */
        preView: function (type, gadget_title, gadget_url, feed_id = 0) {
            if (type == __TYPE_OPEN_SOCIAL) {
                // if opensocial gadget then display it using shindig
                $app.gadget.displayView(__HOME, gadget_url, 13)
            } else {
                if (!$app.gen.ishttp(gadget_url)) {
                    gadget_url = 'http://' + gadget_url
                }
                let tab_id = 999999999
                let uniq_id = 99999
                let key = tab_id + '-' + uniq_id
                // if RSS gadget then display it using internal feed gadget
                // Tab object.
                $app._tab[tab_id] = {
                    title: 'Testing',
                    template: 13,
                    theme_id: 99999,
                    lcon: ''
                }
                // Gadget object
                $app._gadget[key] = {
                    tab_id: tab_id,
                    uniq_id: uniq_id,
                    posx: 1,
                    posy: 1,
                    module_id: 0,
                    feed_id: _.parseInt(feed_id),
                    title: gadget_title,
                    variables: '',
                    type: __TYPE_FEED,
                    style: '',
                    feed_entries: __FEED_DEFAULT_ENTRIES,
                    feed_display: __FEED_DEFAULT_DISPLAY,
                    need_auth: 0,
                    feed_auth: '',
                    minimised: 0,
                    autorefresh: 0,
                    url: gadget_url,
                    icon: '',
                    height: 0,
                    status: 'Available',
                    lang: 'en',
                    website: '',
                    thumb: ''
                }

                $app.tab.loadTemplate(tab_id) // create template for preview
                $app.gadget.loadTemplate(key) // create gadget template
                $app.feed.loadFeed(key) // display feeds in gadget
            }
        },

        /*
         * $app.gadget.displayView : Display gadget in home/canvas view for testing purpose
         * Params   : gadget_url - gadget url to render
         *          : view - home/canvas
         *          : template - gadget render template
         * Returns  : None
         */
        displayView: function (view, gadget_url, template) {
            if (gadget_url == __indef) {
                gadget_url = $('input#gadgetURL').val()
            }
            if (!$app.gen.ishttp(gadget_url)) {
                gadget_url = 'http://' + gadget_url
            }
            let modulePrefs = __indef
            let gadgetTitle = 'Testing Gadget'
            let tab_id = 999999999
            let uniq_id = 99999
            let key = tab_id + '-' + uniq_id
            if (template == __indef) {
                template = (view == __HOME) ? 11 : 12
            }
            CommonContainer.preloadGadget(gadget_url, function (result) {
                for (let gadget_url in result) {
                    if (!result[gadget_url].error) {
                        if (result[gadget_url].modulePrefs !== __indef) {
                            // load module preferences for the gadget
                            modulePrefs = result[gadget_url].modulePrefs
                            if (modulePrefs['title'] !== __indef) {
                                gadgetTitle = modulePrefs['title']
                            }
                            // get the module scrolling value (yes/no)
                            $app.pref.modulePrefs(result[gadget_url].modulePrefs)
                        }
                        // Tab object.
                        $app._tab[tab_id] = {
                            title: 'Testing',
                            template: template,
                            theme_id: 99999,
                            lcon: ''
                        }
                        // Gadget object
                        $app._gadget[key] = {
                            tab_id: tab_id,
                            uniq_id: uniq_id,
                            posx: 1,
                            posy: 1,
                            module_id: 99999,
                            feed_id: 0,
                            title: gadgetTitle,
                            variables: '',
                            type: __TYPE_OPEN_SOCIAL,
                            style: '',
                            feed_entries: 0,
                            feed_display: '',
                            need_auth: 0,
                            feed_auth: '',
                            minimised: 0,
                            autorefresh: 0,
                            url: gadget_url,
                            icon: '',
                            height: 0,
                            gstatus: 'A',
                            lang: 'en',
                            website: '',
                            thumb: ''
                        }
                        if (result[gadget_url].userPrefs !== __indef && CommonContainer.EnablePreferences) {
                            // load user preferences for the gadget depend on gadget object
                            $app.pref.userPrefs(key, result[gadget_url].userPrefs, view)
                        }
                        $('#submitDesc').remove()
                        $('#widget-grid').empty()
                        $app.tab.loadTemplate(tab_id)
                        $app.gadget.loadTemplate(key) // create gadget template
                        $app.shindig.displayGadget(result, key, view) // Display gadget
                    } else {
                        let errorMsg = 'Oops, There is error rendering gadget. ' + result[gadget_url].error.message
                        toastr['error'](errorMsg)
                    }
                }
            })
        },

        /*
         * $app.gadget.displaySubmitForm : Display Gadget submit form
         * Params   : None
         * Returns  : None
         */
        displaySubmitForm: function () {
            // @formatter:off
            let l_s = '<div class="row">'
                        + '<div class="col-sm-10 offset-sm-1 col-md-8 offset-md-2 mt-2">'
                            + '<form id="formSubmitGadget" action="">'
                                + '<div class="form-group">'
                                    + '<div class="col-sm-12">'
                                        + '<input type="text" class="form-control" placeholder="Enter your gadget xml URL" id="gadgetURL" name="gadgetURL" autofocus>'
                                    + '</div>'
                                + '</div>'
                                + '<div class="form-group">'
                                    + '<div class="col-sm-12 text-center">'
                                        + '<button type="button" onclick=\'$app.gadget.displayView("' + __HOME + '"); return false; \' class="btn btn-primary font-weight-bold font-family-nunito mr-2 mt-2">Home View</button>'
                                        + '<button type="button" onclick=\'$app.gadget.displayView("' + __CANVAS + '"); return false; \' class="btn btn-primary font-weight-bold font-family-nunito mr-2 mt-2">Canvas View</button>'
                                        + '<button type="submit" onclick=\'$app.gadget.submitValidate(); return false; \' id="btnSubmitGadget" class="btn btn-success font-weight-bold font-family-nunito mt-2">Validate Gadget</button>'
                                    + '</div>'
                                + '</div>'
                            + '</form>'
                        + '</div>'
                        + '<div class="col-sm-12 col-md-10 offset-md-1 mt-4" id="submitDesc">'
                            + '<blockquote class="blockquote">'
                                + '<p>Please make sure gadget has below <strong>ModulePrefs</strong>. Don\'t submit <strong>Test Gadget</strong> it will not be approved by admin.</p>'
                            + '</blockquote>'

                            + '<dl class="row mt-4">'
                                + '<dt class="col-sm-3">title</dt>'
                                + '<dd class="col-sm-9">This title is displayed in the gadget title bar.</dd>'

                                + '<dt class="col-sm-3">title_url</dt>'
                                + '<dd class="col-sm-9">URL that the gadget title links to.</dd>'

                                + '<dt class="col-sm-3">category</dt>'
                                + '<dd class="col-sm-9">Directory category to list gadget. (lifestyle,tools,etc)</dd>'

                                + '<dt class="col-sm-3">description</dt>'
                                + '<dd class="col-sm-9">Describes the gadget. </dd>'

                                + '<dt class="col-sm-3">author</dt>'
                                + '<dd class="col-sm-9">Author of the gadget.</dd>'

                                + '<dt class="col-sm-3">author_email</dt>'
                                + '<dd class="col-sm-9">The gadget author\'s email address.</dd>'

                                + '<dt class="col-sm-3">screenshot</dt>'
                                + '<dd class="col-sm-9">URL of a gadget screenshot, should be 280 pixels wide.</dd>'

                                + '<dt class="col-sm-3">thumbnail</dt>'
                                + '<dd class="col-sm-9">URL of a gadget thumbnail, should be 120x60 pixels.</dd>'

                                + '<dt class="col-sm-3">height</dt>'
                                + '<dd class="col-sm-9">Gadget height.</dd>'
                            + '</dl>'
                        + '</div>'
                    + '</div>';

            // @formatter:on
            // Display Gadget submission form
            $('#submit-form').empty().append(l_s)
        },

        /*
         * $app.gadget.submitValidate : Validate gadget submitted and call function to store details in DB
         * Params   : gadget_url - URL of the gadget XML
         * Returns  : None
         */
        submitValidate: function (gadget_url) {
            if (gadget_url == __indef) {
                gadget_url = $('input#gadgetURL').val()
            }
            if (!$app.gen.ishttp(gadget_url)) {
                gadget_url = 'http://' + gadget_url
            }
            let modulePrefs = __indef

            CommonContainer.preloadGadget(gadget_url, function (result) {
                for (let gadget_url in result) {
                    if (!result[gadget_url].error) {
                        if (result[gadget_url].modulePrefs !== __indef) {
                            // load user preferences for the gadget
                            modulePrefs = result[gadget_url].modulePrefs
                        }

                        // @formatter:off
                        let l_s = '<div class="row">'
                                    + '<div class="col-sm-12 col-md-10 offset-md-1 mt-2">'
                                        + '<blockquote class="blockquote">'
                                            + '<p>Please verify <strong>ModulePrefs</strong> of this gadget, if needed please make necessary changes in XML and resubmit.</p>'
                                        + '</blockquote>'

                                        + '<dl class="row mt-4">'
                                            + '<dt class="col-sm-3">gadget_url</dt>'
                                            + '<dd class="col-sm-9">' + gadget_url + '</dd>';
                                            // Display details on page
                                            for (var k in modulePrefs) {
                                                if (k != 'links' && k != 'features') {
                                                    l_s += '<dt class="col-sm-3">' + k + '</dt>';
                                                    l_s += '<dd class="col-sm-9">' + modulePrefs[k] + '</dd>';
                                                }
                                            }
                                            let modPrefs = $app.gen.serialise(modulePrefs);
                                    l_s += '</dl>'
                                    + '</div>'
                                    + '<div class="col-sm-12 text-center mb-4">'
                                        + '<button type="button" onclick=\'$app.gadget.displaySubmitForm(); return false; \' id="btnCancelGadget" class="btn btn-danger font-weight-bold font-family-nunito mr-2 mt-2">Need Changes</button>'
                                        + '<button type="button" onclick=\'$app.gadget.submitGadget(' + modPrefs + ',"' + gadget_url + '"); return false; \' id="btnSubmitGadget" class="btn btn-success font-weight-bold font-family-nunito btn-submit mt-2">Submit Gadget</button>'
                                    + '</div>'
                                + '</div>';
                        // @formatter:on

                        $('#widget-grid').empty()
                        $('#submit-form').empty().append(l_s)
                    } else {
                        let errorMsg = 'Oops, There is error rendering gadget : ' + result[gadget_url].error.message
                        toastr['error'](errorMsg)
                    }
                }
            });
        },

        /*
         * $app.gadget.submitGadget : Submit gadget to directory
         * Params   : modulePrefs - Gadget module preferences.
         *          : gadget_url - Gadget URL
         * Returns  : None
         */
        submitGadget: function (modulePrefs, gadget_url) {
            $app.gen.buttonLoading('btn-submit', true) // show loading on button

            // save gadget to directory
            $.ajax({
                url: '/api/gadgets/submit',
                data: { gadget_prefs: modulePrefs, gadget_url: gadget_url },
                type: 'POST',
                dataType: 'json',
                cache: false,
                async: true
            })
              .done(function (response) {
                  let gadget_id = _.has(response, 'gadget_id') ? _.parseInt(response.gadget_id) : null
                  $app.gen.commonDoneResponseMessage(response)

                  if (gadget_id) {
                      // @formatter:off
                        let l_s = '<div class="row">'
                                    + '<div class="col-sm-10 offset-sm-1 col-md-8 offset-md-2 mt-2">'
                                        + '<blockquote class="blockquote">'
                                            + '<p>Congratulations! your gadget is submitted successfully. Please note it may take few days to appear in the directory.</p>'
                                        + '</blockquote>'

                                        + '<div class="text-center mt-4">'
                                            + '<button type="button" onclick=\'$app.tab.addGadget(' + gadget_id + ',' + $app._user.active_tab + ', this); return false; \' id="btnAddGadget" class="btn btn-success font-weight-bold font-family-nunito mr-2">Add to Current Tab</button>'
                                            + '<button type="button" onclick=\'$app.gadget.displaySubmitForm(); return false; \' id="btnSubmitMore" class="btn btn-primary font-weight-bold font-family-nunito mr-2">Submit Another Gadget</button>'
                                        + '</div>'
                                    + '</div>'
                                + '</div>';
                        // @formatter:on

                      $('#submit-form').empty().append(l_s)
                  } else {
                      toastr['error']('Oops! Something went wrong, please try again.')
                      $app.gen.buttonLoading('btn-submit', false, 'Submit Gadget') // hide loading on button
                  }
              })
              .fail(function (jqXHR, textStatus, errorThrown) {
                  $app.gen.buttonLoading('btn-submit', false, 'Submit Gadget') // hide loading on button
                  $app.gen.commonFailResponseMessage(jqXHR)
              });
        },

        /*
         * $app.gadget.embedGadget : Embed this gadget on your website.
         * Params   : key : Unique key of the gadget
         * Returns  : None
         */
        embedGadget: function (key) {
            let l_prefs = $app.gen.deserialise($app._gadget[key].variables)
            let param = ''
            for (let k in l_prefs) {
                param += '&up_' + k + '=' + encodeURIComponent(l_prefs[k])
            }
            let link = __BASEURL + 'shindig/gadgets/ifr?url=' + $app._gadget[key].url + '&lang=en&country=ALL' + ((param) ? param : '')

            // @formatter:off
            let l_s = '<div class="row">'
                        + '<div class="col-12 mb-2">'
                            + '<ul><li><h5>Copy below code and paste it in your webpage HTML where you want to display this gadget.</h5></li>'
                            + '<li><h5>Change iframe height & width according to content.</h5></li></ul>'
                            + '<div class="mt-4"><pre>&lt;iframe style="width: 100%; height: 350px;"'
                                + ' src="' + link + '"'
                                + ' allowTransparency="true" frameborder="0" scrolling="auto"&gt;&lt;/iframe&gt;</pre></div>'
                        + '</div>'
                    + '</div>';
            // @formatter:on

            bootbox.dialog({
                message: l_s,
                title: 'Embed Gadget on your Website',
                buttons: {
                    success: {
                        label: '<i class="fas fa-times mr-2"></i>Close',
                        className: 'btn-sm btn-light font-family-nunito font-weight-bold',
                    }
                }
            })
        },

        /*
         * $app.gadget.flagGadget : Flag gadget - not working, adult contents, so many ads etc
         * Params   : key : Unique key of the gadget
         * Returns  : None
         */
        flagGadget: function (key) {
            if ($app._user.logged === false) {
                toastr['error']('Please login to report this Gadget to us.')
                return
            }

            // report gadget/feed not working, adult content etc
            $.ajax({
                url: '/api/gadgets/flag',
                data: {
                    type: $app._gadget[key].type,
                    feed_id: $app._gadget[key].feed_id,
                    gadget_id: $app._gadget[key].module_id
                },
                type: 'PATCH',
                dataType: 'json',
                cache: false,
                async: true
            })
              .done(function (response) {
                  $app.gen.commonDoneResponseMessage(response)
              })
              .fail(function (jqXHR, textStatus, errorThrown) {
                  $app.gen.commonFailResponseMessage(jqXHR)
              })
        },

        /*
         * $app.gadget.contactDeveloper : Show gadget Author and Submitter contact details
         * Params   : key : Unique key of the gadget
         * Returns  : None
         */
        contactDeveloper: function (key) {
            if ($app._user.logged === false) {
                toastr['error']('Please login to get contact email of Gadget Developer.')
                return
            }
            // Get gadget author details
            $.ajax({
                url: '/api/gadgets/get-author',
                data: {
                    type: $app._gadget[key].type,
                    feed_id: $app._gadget[key].feed_id,
                    gadget_id: $app._gadget[key].module_id
                },
                type: 'GET',
                dataType: 'json',
                cache: false,
                async: true
            })
              .done(function (response) {
                  let author_name = _.has(response, 'name') ? response.name : 'Developer'
                  let author_email = _.has(response, 'email') ? response.email : null
                  let module_id = _.has(response, 'gadget_id') ? _.parseInt(response.gadget_id) : null

                  if (author_email) {
                      let gadget_url = null
                      if (module_id) {
                          gadget_url = __BASEURL + 'directory/gadgets/' + module_id
                      } else {
                          gadget_url = $app._gadget[key].url
                      }

                      // @formatter:off
                        let link = '<a type="button" class="btn btn-success font-weight-bold font-family-nunito" href="mailto:' + author_email + '?subject=Regarding your gadget&body=Hi ' + author_name + ', Gadget URL : ' + encodeURIComponent(gadget_url) + '"><i class="fas fa-envelope mr-2"></i>Send email to Developer</a>';
                        // Display it on screen
                        let l_s = '<div class="row">'
                                    + '<div class="col-sm-10 offset-sm-1">'
                                    + ((author_name) ? '<h5>Developer Name: <strong>' + author_name + '</strong></h5>' : '')
                                        + '<h5 class="mt-3">' + link + '</h5>'
                                    + '</div>'
                                + '</div>';
                        // @formatter:on

                      bootbox.dialog({
                          message: l_s,
                          title: 'Contact Gadget Developer',
                          buttons: {
                              success: {
                                  label: '<i class="fas fa-arrow-left mr-2"></i>Cancel',
                                  className: 'btn-sm btn-light font-family-nunito font-weight-bold',
                              }
                          }
                      })
                  }
              })
              .fail(function (jqXHR, textStatus, errorThrown) {
                  $app.gen.commonFailResponseMessage(jqXHR)
              });
        }
    },

    /*------------------------------------------------------------------------------------------------*\
     * Class    :   $app.header
     * Desc     :   App header related functions
     \*-----------------------------------------------------------------------------------------------*/
    header: {
        /*
         * $app.header.displayTabMenu : display tab menu
         * Params   : None
         * Returns  : None
         */
        displayTabMenu: function () {
            let l_s = ''
            if ($app._tab[$app._user.active_tab].icon) {
                l_s = '<img class="selected-tab mr-2" src="' + __BASEURL + __TAB_ICON_UPLOAD_DIR + $app._tab[$app._user.active_tab].icon + '">'
            }

            l_s += $app.gen.truncate($app._tab[$app._user.active_tab].title, __TAB_TITLE_LENGTH, '...') + '<i class=\'fas fa-fw fa-chevron-down mx-1\'></i>'
            // replace the tab name with newly selected
            $('#tab_active').empty().append(l_s).show()

            l_s = ''
            $.each($app._gen.tab_order, function (index, value) {
                if (value !== $app._user.active_tab) {
                    l_s += '<a class="dropdown-item" href="#" onclick=\'$app.tab.redirect(' + value + '); return false; \'>'
                    if ($app._tab[value].icon) {
                        l_s += '<img class="mr-2" src="' + __BASEURL + __TAB_ICON_UPLOAD_DIR + $app._tab[value].icon + '">'
                    }
                    l_s += $app.gen.truncate($app._tab[value].title, __TAB_TITLE_LENGTH, '...') + '</a>'
                }
            })
            // other setting options
            l_s += '<div class="dropdown-divider"></div>'
            l_s += '<a class="dropdown-item" href="#" onclick=\'$app.setting.addTab(); return false; \'><i class="fas fa-fw fa-plus-square text-success mr-1"></i>' + 'Add Tab' + '</a>'
            l_s += '<a class="dropdown-item" href="#" onclick=\'$app.setting.deleteTab(); return false; \'><i class="fas fa-fw fa-trash-alt text-danger mr-1"></i>' + 'Delete Tab' + '</a>'
            l_s += '<a class="dropdown-item" href="#" onclick=\'$app.tab.options(); return false; \'><i class="fas fa-fw fa-cog text-primary mr-1"></i>' + 'Tab Options' + '</a>'

            // rearrange the tab menu based on tab selection
            $('#tab_menu').empty().append(l_s)
        }
    },
    /*------------------------------------------------------------------------------------------------*\
     * Class    :   $app.feed
     * Desc     :   Feed loader functions
     \*-----------------------------------------------------------------------------------------------*/

    feed: {
        /*
         * $app.feed.loadFeed : Load feed using google or internal feed fetcher
         * Params   : uniq.id - current processing unique id
         *          : view - home, canvas or default
         *          : page - current page number
         *          : show_loading - show loading icon if true or empty else dont
         * Returns  : None
         */
        loadFeed: function (key, view, page, show_loading) {
            if (view == __indef) {
                view = __HOME
            }
            if (page == __indef) {
                page = 1
            }
            // show loading gadget
            if (show_loading == __indef || show_loading) {
                $app.gadget.loading(key)
            }

            // get required details for current user
            $.ajax({
                url: '/api/articles/get-articles',
                data: {
                    key: key, page: page, view: view,
                    feed_id: $app._gadget[key].feed_id,
                    feed_url: $app._gadget[key].url,
                    feed_thumb: $app._gadget[key].thumb,
                    feed_entries: $app._gadget[key].feed_entries,
                    feed_display: $app._gadget[key].feed_display,
                    need_auth: $app._gadget[key].need_auth,
                    feed_auth: $app._gadget[key].feed_auth
                },
                type: 'POST',
                dataType: 'json',
                cache: false,
                async: true
            })
              .done(function (response) {
                  // uniq key [tab_id + '-' + uniq_id] to identify which gadget to display.
                  let key = _.has(response, 'key') ? response.key : null
                      if (key) {
                          let gadget_id = '#wid-id-' + key

                      // Display contents
                          $(gadget_id).find('.widget-body').empty()
                      $(gadget_id).find('.widget-body').append(response.articlesHtml)
                  }
              })
              .fail(function (jqXHR, textStatus, errorThrown) {
                  // TODO: Need to handle feed call fail
              })
        },


        /*
         * $app.tab.addFeed : Add feed to tab
         * Params   : feed_url - Feed URL
         *          : tab_id - Tab ID
         *          : js_obj - current js object used for disabling button
         * Returns  : None
         */
        addFeed: function (feed_url, tab_id, js_obj) {
            if (tab_id === __indef) {
                tab_id = null
            }

            // Add given feed to the tab
            $.ajax({
                url: '/api/feeds/add-feed',
                data: { tab_id: tab_id, feed_URL: feed_url, feed_auth: null },
                type: 'POST',
                dataType: 'json',
                cache: false,
                async: true
            })
              .done(function (response) {
                  $app.gen.commonDoneResponseMessage(response)
                  $(js_obj).prop('disabled', true).html('Added')
              })
              .fail(function (jqXHR, textStatus, errorThrown) {
                  $app.gen.commonFailResponseMessage(jqXHR)
              })
        },

        /*
         * $app.feed.checkFeed : Check the rss feed
         * Params   : feed_URL - rss feed url
         *      feed_auth - authentication string
         *      has_multiple - adding multiple feeds available on given website
         *      js_obj - current js object used for disabling button
         * Returns  : false
         */
        checkFeed: function (feed_URL, feed_auth, has_multiple, js_obj) {
            if (!$app.gen.ishttp(feed_URL)) {
                feed_URL = 'http://' + feed_URL
            }
            if (feed_auth == __indef) {
                feed_auth = ''
            }
            if (has_multiple == __indef) {
                has_multiple = false
            }

            // check if feed already exist then add to user tab if not
            // then search the feed urls available for website.
            $.ajax({
                url: '/api/feeds/add-feed',
                data: { tab_id: $app._user.active_tab, feed_URL: feed_URL, feed_auth: feed_auth },
                type: 'POST',
                dataType: 'json',
                cache: false,
                async: true
            })
              .done(function (response) {
                  // feed already exist and added successfully
                  $app.gen.commonDoneResponseMessage(response)
                  // this is find rss feeds on given website or url
                  let feedUrlList = _.has(response, 'feedUrlList') ? response.feedUrlList : null
                  let responseCode = _.has(response, 'responseCode') ? response.responseCode : null

                  // check if feed url needs authorization then show add feed modal with username and password
                  if (responseCode == __HTTP_UNAUTHORIZED) {
                      $app.tab.addRss(feed_URL, 1)
                      return false
                  }

                  // if there are feeds url available for given website then display it
                  if (feedUrlList !== null) {
                      $app.feed.displayFeedLinks(feedUrlList, feed_URL)
                      return true
                  }

                  // single feed and it is successfully added
                  if (has_multiple == false) {
                      // hide bootbox model
                      bootbox.hideAll()
                      // reload tab with newly added feed
                      $app.tab.reload($app._user.active_tab)
                      return true
                  }

                  if (_.isObject(js_obj)) {
                      $(js_obj).prop('disabled', true).html('Added')
                  }

                  return false
              })
              .fail(function (jqXHR, textStatus, errorThrown) {
                  $app.gen.buttonLoading('btn-submit', false, 'Add Feed') // hide loading on button
                  $app.gen.commonFailResponseMessage(jqXHR)
                  return false
              })
        },

        /*
         * $app.feed.displayFeedLinks : display available feed links for given url
         * Params   :
         *      response - json response with links available to add
         *      feedURL - Feed URL
         * Returns  : false
         */
        displayFeedLinks: function (response, feedURL) {
            // hide bootbox model
            bootbox.hideAll()

            // get the first tab id as default tab to load
            let links = _.size(response) ? response : null
            if (links) {
                let linksHtml = '<div class="row">'
                  + '<div class="col-md-12 mb-2">'
                  + '<div class="tab-options">'
                  + '<ul class="tab-list">'
                $.each(links, function (index, value) {
                    let title = _.has(value, 'title') ? value.title : value.href
                    linksHtml += '<li class="d-flex justify-content-between">'
                      + '<span class="text">'
                      + '<a href="' + value.href + '" target="_blank">' + title + '</a>'
                      + '</span>'
                      + '<span>'
                      + '<button type="button" class="btn btn-sm btn-primary font-weight-bold font-family-nunito" onclick=\'$app.feed.checkFeed("' + value.href + '", "", true, this); return false; \' id="applyButton">Add Feed</button>'
                      + '</span>'
                      + '</li>'
                })
                linksHtml += '</ul>'
                  + '</div>'
                  + '</div>'
                  + '</div>'
                // display all feeds in modal
                bootbox.dialog({
                    closeButton: false,
                    message: linksHtml,
                    title: 'Feeds Available',
                    buttons: {
                        success: {
                            label: '<i class="fas fa-check mr-2"></i>I am Done',
                            className: 'btn-sm btn-success font-family-nunito font-weight-bold',
                            callback: function () {
                                // reload tab with newly added feed
                                $app.tab.reload($app._user.active_tab)
                            }
                        },
                    }
                })
            } else {
                toastr['error']('Oops! This RSS feed url looks incorrect or currently not available.')
                $app.tab.addRss(feedURL, 0)
            }

            return true
        },

        /*
         * $app.feed.editSetting : Edit preferences setting for Feed Gadget
         * Params   : key - uniq key [tab_id + '-' + uniq_id] to identify which gadget to display.
         *          : view - default/home/canvas/preview
         * Returns  : None
         */
        editSetting: function (key, view) {
            if ($app._user.logged === false) {
                toastr['error']('Please login to change the gadget preferences.')
                return
            }

            let successLabel = 'Update'
            // @formatter:off
            let l_s = '<div class="row">'
                        + '<div class="col-sm-10 offset-sm-1">'
                            +'<form id="formEditFeedPref" action="">'
                                + '<div class="form-group">'
                                    + '<label for="gadgetTitle">Gadget Title</label>'
                                    + '<input type="text" class="form-control" value="' + $app._gadget[key].title + '" id="gadgetTitle" name="gadgetTitle">'
                                + '</div>'
                                + '<div class="form-group">'
                                    + '<label for="numberOfItem">Number of Items</label>'
                                    + '<select class="form-control selectpicker" data-container="body" id="numberOfItem" name="numberOfItem">';
                                            for (var i = 0; i < __FEED_NO_ENTRIES.length; i++) {
                                                if (__FEED_NO_ENTRIES[i] == $app._gadget[key].feed_entries) {
                                                    l_s += '<option value="' + __FEED_NO_ENTRIES[i] + '" selected>' + __FEED_NO_ENTRIES[i] + '</option>';
                                                } else {
                                                    l_s += '<option value="' + __FEED_NO_ENTRIES[i] + '">' + __FEED_NO_ENTRIES[i] + '</option>';
                                                }
                                            }
                                l_s += '</select>'
                                + '</div>'
                                + '<div class="form-group">'
                                    + '<label for="display">Display</label>'
                                    + '<select class="form-control selectpicker" data-container="body" id="display" name="display">';
                                            for (var i = 0; i < __FEED_DISPLAY_STYLE.length; i++) {
                                                if (__FEED_DISPLAY_STYLE[i] == $app._gadget[key].feed_display) {
                                                    l_s += '<option value="' + __FEED_DISPLAY_STYLE[i] + '" selected>' + __FEED_DISPLAY_STYLE[i] + '</option>';
                                                } else {
                                                    l_s += '<option value="' + __FEED_DISPLAY_STYLE[i] + '">' + __FEED_DISPLAY_STYLE[i] + '</option>';
                                                }
                                            }
                                l_s += '</select>'
                                + '</div>';

                        if ($app._gadget[key].need_auth) {
                            l_s += '<div class="form-group">'
                                        + '<label for="login">Feed User Name</label>'
                                        + '<input type="text" class="form-control" id="login" placeholder="RSS feed user name">'
                                    + '</div>'
                                + '<div class="form-group">'
                                    + '<label for="password">Feed Password</label>'
                                    + '<input type="password" class="form-control" id="password" placeholder="RSS feed password">'
                                + '</div>';
                        }
                        l_s += '</form>'
                          + '</div>'
                      + '</div>';
            // @formatter:on

            // Display Form for edit preferences
            bootbox.dialog({
                message: l_s,
                title: 'Edit Gadget Settings',
                buttons: {
                    danger: {
                        label: '<i class="fas fa-arrow-left mr-2"></i>Cancel',
                        className: 'btn-sm btn-light font-family-nunito font-weight-bold',
                    },
                    success: {
                        label: '<i class="fas fa-save mr-2"></i>' + successLabel,
                        className: 'btn-sm btn-success font-family-nunito font-weight-bold btn-submit',
                        callback: function () {
                            $app.gen.buttonLoading('btn-submit', true) // show loading on button

                            let gadget_title = $('input#gadgetTitle').val()
                            let entries = $('select#numberOfItem option:selected').val()
                            let display = $('select#display option:selected').val()
                            let feed_auth = $app._gadget[key].feed_auth
                            if ($('#formEditFeedPref input#login').val() != __indef && $('#formEditFeedPref input#password').val() != __indef) {
                                feed_auth = $app.Base64.encode($('input#login').val() + ':' + $('input#password').val())
                            }

                            // update feed gadget preferences
                            $.ajax({
                                url: '/api/tab-gadgets/update-feed-pref',
                                data: {
                                    tab_id: $app._user.active_tab,
                                    unique_id: $app._gadget[key].uniq_id,
                                    gadget_title: gadget_title,
                                    entries: entries,
                                    display: display,
                                    feed_auth: feed_auth
                                },
                                type: 'POST',
                                dataType: 'json',
                                cache: false,
                                async: true
                            })
                              .done(function (response) {
                                  bootbox.hideAll() // hide bootbox model
                                  $app.gen.commonDoneResponseMessage(response)

                                  // get the delete tabid
                                  let tab_id = _.has(response, 'tab_id') ? response.tab_id : null
                                  let unique_id = _.has(response, 'unique_id') ? response.unique_id : null
                                  if (tab_id && unique_id) {
                                      let key = tab_id + '-' + unique_id
                                      let gadget_id = '#wid-id-' + key

                                      // Change Global _gadget object with new values
                                      let gadget_title = _.has(response, 'gadget_title') ? response.gadget_title : null
                                      $app._gadget[key].title = gadget_title
                                      $app._gadget[key].feed_entries = _.has(response, 'entries') ? _.parseInt(response.entries) : __FEED_DEFAULT_ENTRIES
                                      $app._gadget[key].feed_display = _.has(response, 'display') ? response.display : null
                                      $app._gadget[key].feed_auth = _.has(response, 'feed_auth') ? response.feed_auth : null

                                      // change Title of gadget
                                      $('' + gadget_id + ' #gadgetTitle').html('' + gadget_title + '')
                                      // Reload Gadget
                                      $app.gadget.loadContent(key)
                                  }
                              })
                              .fail(function (jqXHR, textStatus, errorThrown) {
                                  $app.gen.buttonLoading('btn-submit', false, successLabel) // hide loading on button
                                  $app.gen.commonFailResponseMessage(jqXHR)
                              })

                            // keep modal open
                            return false
                        }
                    }
                },
                onShown: function (e) {
                    $app.jq.bootstrapSelect()
                },
            })
        }
    },

    /*------------------------------------------------------------------------------------------------*\
     * Class    :   $app.shindig
     * Desc     :   Apache shindig container
     \*-----------------------------------------------------------------------------------------------*/
    shindig: {
        /*
         * $app.shindig.init : Initilise the apache shindig container
         * Params   : None
         * Returns  : None
         */
        init: function () {
            gadgets.rpc.register('resize_iframe', this.setHeight)
            gadgets.rpc.register('set_pref', this.setUserPref)
            gadgets.rpc.register('userprefs_dialog', this.userprefsDialog)  // custom from blueg
            gadgets.rpc.register('set_title', this.setTitle)
            CommonContainer.rpcRegister('requestNavigateTo', this.requestNavigateTo)
        },

        /* $app.shindig.setHeight - Changes the height of the iframe that contains the gadget
         * Params   : height - New height to be changed
         * Returns  : None
         */
        setHeight: function (height) {
            let element = $('#' + this.f)
            if (element) {
                // Set gadget max height
                if (height > $app._gen.gadget_max_height)
                    height = $app._gen.gadget_max_height
                // Set gadget minimum height
                if (height < $app._gen.gadget_min_auto_height)
                    height = $app._gen.gadget_min_auto_height

                height += 20
                element.height(height + 'px')
            }
        },

        /* $app.shindig.userprefsDialog - Display edit userprefs dialog for custom button. [this is custom function for blueg.com]
         * Params   : None
         * Returns  : None
         */
        userprefsDialog: function () {
            let gadgetSite = this.f
            let key = gadgetSite.replace('__gadget_gadget-site-', '')
            let gadget_id = '#wid-id-' + key
            // Trigger full screen button click event.
            $('' + gadget_id + ' .jarviswidget-edit-btn').trigger('click')
        },

        /*
         * $app.shindig.setUserPref - Sets a gadget preference, this makes an ajax call to portal 'setpref' event using
         * the gadgets security token to identify where it came from (and that it's valid)
         * e.g. it triggers - prefs.set('uniqid', uniqID);
         * param   : editToken
         *         : name - Variable Name
         *         : value - Variable changed value
         * returns : None
         */
        setUserPref: function (editToken, name, value) {
            if ($app._user.logged === false) {
                // user not logged in to don't try to update it
                return
            }

            let gadgetSite = this.f
            let key = gadgetSite.replace('__gadget_gadget-site-', '')
            // get the gadget's current user pref
            let l_prefs = {}
            l_prefs = $app.gen.deserialise($app._gadget[key].variables)

            if (value !== __indef && name !== __indef) {
                l_prefs[name] = value
                $app._gadget[key].variables = $app.gen.serialise(l_prefs)

                // store user preferences in database if user is logged in
                if ($app._user.logged) {
                    // update open social gadget preferences
                    $.ajax({
                        url: '/api/tab-gadgets/update-gadget-pref',
                        data: {
                            tab_id: $app._user.active_tab,
                            unique_id: $app._gadget[key].uniq_id,
                            param: $app._gadget[key].variables,
                            gadget_title: $app._gadget[key].title,
                            view: $app.pref.view
                        },
                        type: 'POST',
                        dataType: 'json',
                        cache: false,
                        async: true
                    })
                      .done(function (response) {
                          // $app.gen.commonDoneResponseMessage(response);
                      })
                      .fail(function (jqXHR, textStatus, errorThrown) {
                          // $app.gen.commonFailResponseMessage(jqXHR);
                      })
                }
            }
        },

        /*
         * $app.shindig.setTitle - Changes the title that's situated above the gadget's iframe to the desired title
         * param    : title - New title to change
         * returns  : None
         */
        setTitle: function (title) {
            if (title !== __indef && title !== '') {
                let gadgetSite = this.f
                let key = gadgetSite.replace('__gadget_gadget-site-', '')
                let gadget_id = '#wid-id-' + key

                let gadget_title = title.replace(/&/g, '&amp;').replace(/</g, '&lt;')
                // change Title of gadget
                $('' + gadget_id + ' #gadgetTitle').html('' + gadget_title + '')
            }
        },

        /*
         * $app.shindig.requestNavigateTo - Navigate between views
         * param    : rpcArgs
         *          : view
         *          : params
         * returns  : None
         */
        requestNavigateTo: function (rpcArgs, view, params) {
            let gadgetSite = rpcArgs.f
            let key = gadgetSite.replace('__gadget_gadget-site-', '')
            let gadget_id = '#wid-id-' + key
            // Trigger full screen button click event.
            $('' + gadget_id + ' .jarviswidget-fullscreen-btn').trigger('click')
        },

        /*
         * Internal function that retrieves the query params from the iframe (used to retrieve the security token in setUserPref)
         * param    : url - url
         * returns  : ret - value pairs
         */
        parseIframeUrl: function (url) {
            // parse the iframe url to extract the key = value pairs from it
            let ret = new Object()
            let hashParams = url.replace(/#.*$/, '').split('&')
            let param = key = val = ''
            for (i = 0; i < hashParams.length; i++) {
                param = hashParams[i]
                key = param.substr(0, param.indexOf('='))
                val = param.substr(param.indexOf('=') + 1)
                ret[key] = val
            }
            return ret
        },

        /*
         * $app.shindig.loadGadget : Load gadget using shindig
         * Params   :
         *      key - uniq key [tab_id + '-' + uniq_id] to identify which gadget to display.
         *      view - view of the gadget Home/Canvas/Default/Preview
         *      action - L - Load & Display Gadget, E - Edit preferences
         * Returns  : None
         */
        loadGadget: function (key, view, action) {
            if (action == __indef) {
                action = __GADGET_LOAD_AND_DISPLAY
            }

            // don't show loading when user click on edit setting
            if (action !== __GADGET_EDIT_PREF) {
                // show loading gadget
                $app.gadget.loading(key)
            }

            let gadget_url = $app._gadget[key].url
            CommonContainer.preloadGadget(gadget_url, function (result) {
                for (let gadget_url in result) {
                    if (!result[gadget_url].error) {
                        // load user preferences for the gadget
                        if (result[gadget_url].userPrefs !== __indef && CommonContainer.EnablePreferences) {
                            $app.pref.userPrefs(key, result[gadget_url].userPrefs, view)
                        }
                        // module prefs like scrolling, height, author, width, thumbnail, etc...
                        if (result[gadget_url].modulePrefs !== __indef) {
                            $app.pref.modulePrefs(result[gadget_url].modulePrefs)
                        }
                        if (action == __GADGET_LOAD_AND_DISPLAY) {
                            $app.shindig.displayGadget(result, key, view) // Display gadget
                        } else {
                            $app.pref.editSetting(key) // edit gadget setting
                        }
                    }
                }
            })
        },

        /*
         * $app.shindig.displayGadget : Display gadget on google site [div]
         * Params   :
         *      result - result from preloadGadget() or {} - in case it is direct add
         *      key - uniq key [tab_id + '-' + uniq_id] to identify which gadget to display.
         *      view - view of the gadget Home/Canvas/Default/Preview
         * Returns  : gadgetSite - Gadget object
         */
        displayGadget: function (result, key, view) {
            result = result || {}
            let module_id = key.replace('-', '')
            let gadget_id = 'gadget-site-' + key
            let viewParams = __indef

            let el = $('#' + gadget_id).get(0)
            let gadget_site = CommonContainer.newGadgetSite(el)

            // stored user preferences valuse.
            let prefs = $app.gen.deserialise($app._gadget[key].variables)
            let renderParams = $app.shindig.renderParms(module_id, prefs, view, $app.pref.height, $app.pref.scroll)

            // load and add gadget to site
            CommonContainer.navigateGadget(gadget_site, $app._gadget[key].url, viewParams, renderParams)
        },

        /*
         * $app.shindig.renderParms : Generate shingig render params
         * Params   :
         *      module_id - The moddule id of this gadget.  Used to identify saved instances of gadgets.
         *                  Defaults to 0, which means the instance of the gadget is not saved.
         *      user_prefs - user preferences [gadget setting variables]
         *      view - view of the gadget Home/Canvas/Default/Preview
         *      height - The starting gadget iframe height (in pixels).
         *      width - The starting gadget iframe width (in pixels)
         *      no_cache - Whether to disable cache.
         *      test_mode - Whether to enable test mode.
         * Returns  : params - object with populated values.
         */
        renderParms: function (module_id, user_prefs, view, height, scroll, width, no_cache, test_mode) {
            let params = {}
            //Evaluate Params based on configuration
            params[osapi.container.RenderParam.MODULE_ID] = (module_id === __indef) ? 0 : module_id
            params[osapi.container.RenderParam.VIEW] = (view === __indef) ? 'default' : view
            params[osapi.container.RenderParam.USER_PREFS] = (user_prefs === __indef) ? false : user_prefs
            // General Other params
            if (height === __indef) {
                height = 0
            }

            if (height > $app._gen.gadget_max_height) {
                height = $app._gen.gadget_max_height
            }

            if (height < $app._gen.gadget_min_height) {
                height = $app._gen.gadget_min_height
            }
            params[osapi.container.RenderParam.HEIGHT] = height
            params[osapi.container.RenderParam.WIDTH] = (width === __indef) ? '100%' : width
            params[osapi.container.RenderParam.NO_CACHE] = (no_cache === __indef) ? true : no_cache
            params[osapi.container.RenderParam.SCROLL] = (scroll === __indef) ? __NO : scroll
            params[osapi.container.RenderParam.TEST_MODE] = (test_mode === __indef) ? false : test_mode
            return params
        }

    },

    /*------------------------------------------------------------------------------------------------*\
     * Class    :   $app.pref
     * Desc     :   gadget preferences functions
     \*-----------------------------------------------------------------------------------------------*/

    pref: {
        prefs_stored: {},
        prefs: {},
        key: '',
        l_s: '',
        view: 'default',
        scroll: '',
        height: 0,

        /*
         * $app.pref.userPrefs : Initialise and load preferences from DB, or get default from gadget userPrefs
         * Params   :
         *      key - uniq key [tab_id + '-' + uniq_id] to identify which gadget to display.
         *      prefs - Gadget preferences
         *      view - home/canvas/default/preview
         * Returns  : None
         */
        userPrefs: function (key, prefs, view) {
            let l_prefs = {}
            this.prefs = prefs
            this.key = key
            if (view !== __indef) {
                this.view = view
            }
            this.prefs_stored = {}
            this.l_s = ''

            l_prefs = $app.gen.deserialise($app._gadget[key].variables)

            // check for additional prefs if they are added to gadget
            for (let k in this.prefs) {
                let pref = this.prefs[k]
                this.prefs_stored[pref.name] = (l_prefs == '' || l_prefs == null || l_prefs[pref.name] == __indef) ?
                  pref.defaultValue : l_prefs[pref.name]
            }

            // Store new sync variables/user prefs to variables.
            $app._gadget[key].variables = $app.gen.serialise(this.prefs_stored)
        },

        /*
         * $app.pref.modulePrefs : Initialise Module prefs like scrolling, height, author, width, thumbnail, etc...
         * Params   :
         *      modulePrefs - Gadget Module Preferences
         * Returns  : None
         */
        modulePrefs: function (prefs) {
            this.scroll = __NO
            if (prefs['scrolling'] !== __indef) {
                this.scroll = (prefs['scrolling']) ? __YES : __NO
            }
            // set the gadget height
            if (prefs['height'] !== __indef) {
                this.height = _.parseInt(prefs['height']) ? _.parseInt(prefs['height']) : 0
            }
        },

        /*
         * $app.pref.editSetting : Edit gadget preferences setting
         * Params   : key - uniq key [tab_id + '-' + uniq_id] to identify which gadget to display.
         * Returns  : None
         */
        editSetting: function (key) {
            if ($app._user.logged === false) {
                toastr['error']('Please login to change the gadget preferences.')
                return
            }
            let successLabel = 'Update'

            // @formatter:off
            this.l_s = '<div class="row">'
                        + '<div class="col-sm-10 offset-sm-1">'
                            + '<form  id="formEditPref"  action="">'
                                + '<div class="form-group">'
                                    + '<label for="gadgetTitle">Gadget Title</label>'
                                    + '<input type="text" class="form-control" value="' + $app._gadget[key].title + '" id="gadgetTitle">'
                                + '</div>';
                                    for (let key in this.prefs) {
                                        let pref = this.prefs[key];
                                        this.addToForm(pref);
                                    }
                    this.l_s += '</form>'
                        + '</div>'
                    + '</div>';
            // @formatter:on

            // Display Form for edit preferences
            bootbox.dialog({
                message: this.l_s,
                title: 'Edit Gadget Settings',
                buttons: {
                    danger: {
                        label: '<i class="fas fa-arrow-left mr-2"></i>Cancel',
                        className: 'btn-sm btn-light font-family-nunito font-weight-bold',
                    },
                    success: {
                        label: '<i class="fas fa-save mr-2"></i>' + successLabel,
                        className: 'btn-sm btn-success font-family-nunito font-weight-bold btn-submit',
                        callback: function () {
                            $app.gen.buttonLoading('btn-submit', true) // show loading on button

                            let gadget_title = $('input#gadgetTitle').val()
                            let formData = $('#formEditPref').serializeArray()
                            // get all checkbox value serializeArray does not get unchecked values
                            let checkbox = $('input:checkbox').map(function () {
                                return { name: this.name, value: this.checked ? this.value : 'false' }
                            })
                            // merge two arrays to first one
                            $.merge(formData, checkbox)
                            let paramObj = formData.reduce(function (obj, arr) {
                                obj[arr.name] = arr.value
                                return obj
                            }, {})

                            let param = $app.gen.serialise(paramObj)

                            // store user preferences in database
                            $.ajax({
                                url: '/api/tab-gadgets/update-gadget-pref',
                                data: {
                                    tab_id: $app._user.active_tab,
                                    unique_id: $app._gadget[$app.pref.key].uniq_id,
                                    param: param,
                                    gadget_title: gadget_title,
                                    view: $app.pref.view
                                },
                                type: 'POST',
                                dataType: 'json',
                                cache: false,
                                async: true
                            })
                              .done(function (response) {
                                  bootbox.hideAll() // hide bootbox model
                                  $app.gen.commonDoneResponseMessage(response)

                                  // get the delete tabid
                                  let tab_id = _.has(response, 'tab_id') ? response.tab_id : null
                                  let unique_id = _.has(response, 'unique_id') ? response.unique_id : null

                                  if (tab_id && unique_id) {
                                      let key = tab_id + '-' + unique_id
                                      let gadget_id = '#wid-id-' + key

                                      // Change Global _gadget object with new values
                                      let gadget_title = _.has(response, 'gadget_title') ? response.gadget_title : null
                                      $app._gadget[key].title = gadget_title
                                      $app._gadget[key].variables = _.has(response, 'param') ? response.param : ''
                                      let view = _.has(response, 'view') ? response.view : null

                                      // change Title of gadget
                                      $('' + gadget_id + ' #gadgetTitle').html('' + gadget_title + '')

                                      // reload gadget contents with new user preferences values
                                      $app.shindig.displayGadget({}, key, view)
                                  }
                              })
                              .fail(function (jqXHR, textStatus, errorThrown) {
                                  $app.gen.buttonLoading('btn-submit', false, successLabel) // hide loading on button
                                  $app.gen.commonFailResponseMessage(jqXHR)
                              })

                            // keep modal open
                            return false
                        }
                    }
                },
                onShown: function (e) {
                    $app.jq.bootstrapSelect()
                },
            })

        },

        /**
         * Add different types of form options based on data types
         * @param pref
         */
        addToForm: function (pref) {
            if (pref.dataType === 'BOOL') {
                this.booleanControl(pref)
            } else if (pref.dataType === 'ENUM') {
                this.enumControl(pref)
            } else if (pref.dataType === 'STRING') {
                this.stringControl(pref)
            } else if (pref.dataType === 'LIST') {
                this.listControl(pref)
            } else if (pref.dataType === 'HIDDEN') {
                this.hiddenControl(pref)
            } else {
                this.stringControl(pref)
            }
        },

        /**
         * Add boolean control
         * @param pref
         */
        booleanControl: function (pref) {
            var defaultValue = this.prefs_stored[pref.name]

            // @formatter:off
            this.l_s += '<div class="form-group">'
                            + '<div class="custom-control custom-switch">'
                                    if (defaultValue == 'true')
                                        this.l_s += '<input type="checkbox" class="custom-control-input" id="' + pref.name + '" name="' + pref.name + '" value="true" checked>';
                                    else
                                        this.l_s += '<input type="checkbox" class="custom-control-input" id="' + pref.name + '" name="' + pref.name + '" value="true">';
                        this.l_s += '<label for="' + pref.name + '" class="custom-control-label">' + pref.displayName + '</label>'
                            + '</div>'
                        + '</div>';
            // @formatter:on
        },

        /**
         * Add boolean control
         * @param pref
         */
        enumControl: function (pref) {
            var defaultValue = this.prefs_stored[pref.name]

            // @formatter:off
            this.l_s += '<div class="form-group">'
                            + '<label for="' + pref.name + '">' + pref.displayName + '</label>'
                            + '<select class="form-control selectpicker" data-container="body" id="' + pref.name + '" name="' + pref.name + '">';
                                for (var i = 0; i < pref.orderedEnumValues.length; i++) {
                                    if (pref.orderedEnumValues[i].value == defaultValue)
                                        this.l_s += '<option value="' + pref.orderedEnumValues[i].value + '" selected>' + pref.orderedEnumValues[i].displayValue + '</option>';
                                    else
                                        this.l_s += '<option value="' + pref.orderedEnumValues[i].value + '">' + pref.orderedEnumValues[i].displayValue + '</option>';
                                }
                    this.l_s += '</select>'
                        + '</div>';
            // @formatter:on
        },

        /**
         * Add string control
         * @param pref
         */
        stringControl: function (pref) {
            var defaultValue = this.prefs_stored[pref.name]

            // @formatter:off
            this.l_s += '<div class="form-group">'
                            + '<label for="' + pref.name + '">' + pref.displayName + '</label>'
                            + '<input type="text" class="form-control" value="' + defaultValue + '" id="' + pref.name + '" name="' + pref.name + '">'
                        + '</div>';
            // @formatter:on
        },

        /**
         * Add list control
         * @param pref
         */
        listControl: function (pref) {
            var defaultValue = this.prefs_stored[pref.name]

            // @formatter:off
            this.l_s += '<div class="form-group">'
                        + '<label for="' + pref.name + '">' + pref.displayName + '</label>'
                        + '<input type="text" class="form-control" value="' + defaultValue + '" id="' + pref.name + '" name="' + pref.name + '">'
                    + '</div>';
            // @formatter:on
        },

        /**
         * Add hidden input field
         * @param pref
         */
        hiddenControl: function (pref) {
            var currentValue = this.prefs_stored[pref.name]

            this.l_s += '<input type="hidden" title="' + pref.name + '" value="' + currentValue + '" id="' + pref.name + '" name="' + pref.name + '">'
        }
    },

    /*------------------------------------------------------------------------------------------------*\
     * Class    :   $app.setting
     * Desc     :   Portal settings related functions
     \*-----------------------------------------------------------------------------------------------*/

    setting: {
        /*
         * $app.setting.saveGadgetPosition : Save gadgets move
         * Params   : None
         * Returns  : None
         */
        saveGadgetPosition: function () {
            if ($app._user.logged) {
                let positionArr = []
                let $sortable_grid = $('#' + $app._user.active_tab + ' .sortable-grid')
                $sortable_grid.each(function () {
                    let subArr = []
                    $(this).children('.jarviswidget').each(function () {
                        let subObj = {}
                        let unique_id = $(this).attr('id').split('-')
                        subObj['unique_id'] = unique_id[3]
                        subArr.push(subObj)
                    })
                    let out = {
                        'section': subArr
                    }
                    positionArr.push(out)
                })

                // save new position to database
                $.ajax({
                    url: '/api/tab-gadgets/update-gadgets-order',
                    data: { tab_id: $app._user.active_tab, position: positionArr },
                    type: 'POST',
                    dataType: 'json',
                    cache: false,
                    async: true
                })
                  .done(function (response) {
                      $app.gen.commonDoneResponseMessage(response)
                  })
                  .fail(function (jqXHR, textStatus, errorThrown) {
                      $app.gen.commonFailResponseMessage(jqXHR)
                  })
            }
        },

        /*
         * $app.setting.hideShow : Hide or Show widget content
         * Params   :
         *      unique_id - Gadget unique ID
         *      satus - 0 : show & 1 - hide
         * Returns  : None
         */
        hideShow: function (unique_id, status) {
            if ($app._user.logged) {
                // save minimised to database
                $.ajax({
                    url: '/api/tab-gadgets/update-gadget-is-minimised',
                    data: { tab_id: $app._user.active_tab, unique_id: unique_id, minimised: status },
                    type: 'POST',
                    dataType: 'json',
                    cache: false,
                    async: true
                })
                  .done(function (response) {
                      $app.gen.commonDoneResponseMessage(response)
                  })
                  .fail(function (jqXHR, textStatus, errorThrown) {
                      $app.gen.commonFailResponseMessage(jqXHR)
                  })
            }
        },

        /*
         * $app.setting.removeModule : Remove module from current tab
         * Params   : posx - position x of gadget
         *          : unique_id - Gadget unique ID
         * Returns  : None
         */
        removeModule: function (unique_id, posx) {
            if ($app._user.logged) {
                // remove gadget from given tab
                $.ajax({
                    url: '/api/tab-gadgets/remove-gadget-from-tab',
                    data: { tab_id: $app._user.active_tab, unique_id: unique_id, posx: posx },
                    type: 'DELETE',
                    dataType: 'json',
                    cache: false,
                    async: true
                })
                  .done(function (response) {
                      $app.gen.commonDoneResponseMessage(response)
                  })
                  .fail(function (jqXHR, textStatus, errorThrown) {
                      $app.gen.commonFailResponseMessage(jqXHR)
                  })
            }
        },

        /*
         * $app.setting.saveModuleStyle : Save module's custom style
         * Params   :
         *      unique_id - Gadget unique ID
         *      style - Gadget style [green, purple etc..]
         * Returns  : None
         */
        saveModuleStyle: function (unique_id, style) {
            if ($app._user.logged) {
                // remove gadget from given tab
                $.ajax({
                    url: '/api/tab-gadgets/update-gadget-style',
                    data: { tab_id: $app._user.active_tab, unique_id: unique_id, style: style },
                    type: 'POST',
                    dataType: 'json',
                    cache: false,
                    async: true
                })
                  .done(function (response) {
                      $app.gen.commonDoneResponseMessage(response)
                  })
                  .fail(function (jqXHR, textStatus, errorThrown) {
                      $app.gen.commonFailResponseMessage(jqXHR)
                  })
            }
        },

        /*
         * $app.setting.addTab : add tab to current user portal
         * Params   : None
         * Returns  : None
         */
        addTab: function () {
            let successLabel = 'Add Tab'
            if ($app._user.logged === false) {
                toastr['error']('Please login to Add Tab to your Portal.')
                return
            }

            // @formatter:off
            let l_s = '<form id="formAddTab" action="">'
                    + '<div class="form-group">'
                        + '<label for="tabTitle">Tab Name</label>'
                        + '<input type="text" class="form-control" id="tabTitle" placeholder="Enter a Tab Name">'
                    + '</div>'
                    + '<div class="form-group">'
                        + '<label for="tabTemplate">Tab Layout</label>'
                        + '<select class="form-control selectpicker" data-container="body" id="tabTemplate">';
                            for (var i = 0; i < __TAB_TEMPLATE_VALUE.length; i++) {
                                if (__TAB_TEMPLATE_VALUE[i] == __TAB_DEFAULT_TEMPLATE) {
                                    l_s += '<option value="' + __TAB_TEMPLATE_VALUE[i] + '" selected>' + __TAB_TEMPLATE_NAME[i] + '</option>';
                                } else {
                                    l_s += '<option value="' + __TAB_TEMPLATE_VALUE[i] + '">' + __TAB_TEMPLATE_NAME[i] + '</option>';
                                }
                            }
                    l_s += '</select>'
                    + '</div>'
                + '</form>';
            // @formatter:on

            bootbox.dialog({
                title: 'Add Tab',
                message: l_s,
                buttons: {
                    danger: {
                        label: '<i class="fas fa-arrow-left mr-2"></i>Cancel',
                        className: 'btn-sm btn-light font-family-nunito font-weight-bold',
                    },
                    success: {
                        label: '<i class="fas fa-plus-square mr-2"></i>' + successLabel,
                        className: 'btn-sm btn-success font-family-nunito font-weight-bold btn-submit',
                        callback: function () {
                            let tab_title = $('input#tabTitle').val()
                            let tab_template = $('select#tabTemplate option:selected').val()
                            $app.gen.buttonLoading('btn-submit', true) // show loading on button

                            // Add new tab to user's portal
                            $.ajax({
                                url: '/api/tabs/add-tab',
                                data: { tab_title: tab_title, tab_template: tab_template },
                                type: 'POST',
                                dataType: 'json',
                                cache: false,
                                async: true
                            })
                              .done(function (response) {
                                  // get the newly added tabid
                                  let tab_id = _.has(response.data, 'id') ? response.data.id : null
                                  if (tab_id) {
                                      // add new tab in the list of tabs
                                      $app._tab[tab_id] = {
                                          title: response.data.title,
                                          template: _.parseInt(response.data.template),
                                          theme_id: _.parseInt(response.data.theme_id),
                                          icon: response.data.icon
                                      }
                                      // add new tab to tab_order array to display in menu
                                      $app._gen.tab_order.push(tab_id)
                                      // hide bootbox model
                                      bootbox.hideAll()
                                      toastr['success']('Tab added successfully to portal.')
                                      // redirect to new tab
                                      $app.tab.redirect(tab_id)
                                  } else {
                                      toastr['error']('Oops! Something went wrong, please try again.')
                                      $app.gen.buttonLoading('btn-submit', false, successLabel) // hide loading on button
                                  }
                              })
                              .fail(function (jqXHR, textStatus, errorThrown) {
                                  $app.gen.buttonLoading('btn-submit', false, successLabel) // hide loading on button
                                  $app.gen.commonFailResponseMessage(jqXHR)
                              })
                            // keep modal open
                            return false
                        }
                    }
                },
                onShown: function (e) {
                    $app.jq.bootstrapSelect()
                },
            })
        },

        /*
         * $app.setting.deleteTab : Delete tab from portal
         * Params   : None
         * Returns  : None
         */
        deleteTab: function () {
            let successLabel = 'Delete Tab'
            if ($app._user.logged === false) {
                toastr['error']('Please login to Delete Tab from your Portal.')
                return
            }

            // @formatter:off
            let l_s = '<form id="formDeleteTab" action="">'
                        + '<blockquote class="blockquote">'
                            + '<strong>Warning</strong> : It will also deletes all gadgets from the tab. This action cannot be undone.'
                        + '</blockquote></div>'
                        + '<div class="form-group">'
                            + '<label for="tabTemplate">Select Tab</label>'
                            + '<select class="form-control selectpicker" data-container="body" id="tabDelete">';
                                    $.each($app._gen.tab_order, function (index, value) {
                                        if ($app._user.active_tab == value) {
                                            l_s += '<option value="' + value + '" selected>' + $app._tab[value].title + '</option>';
                                        } else {
                                            l_s += '<option value="' + value + '">' + $app._tab[value].title + '</option>';
                                        }
                                    });
                        l_s += '</select>'
                        + '</div>'
                    + '</form>';
            // @formatter:on

            bootbox.dialog({
                title: 'Delete Tab',
                message: l_s,
                buttons: {
                    danger: {
                        label: '<i class="fas fa-arrow-left mr-2"></i>Cancel',
                        className: 'btn-sm btn-light font-family-nunito font-weight-bold',
                    },
                    success: {
                        label: '<i class="fas fa-trash-alt mr-2"></i>' + successLabel,
                        className: 'btn-sm btn-danger font-family-nunito font-weight-bold btn-submit',
                        callback: function () {
                            let tab_id = $('select#tabDelete option:selected').val()
                            $app.gen.buttonLoading('btn-submit', true) // show loading on button

                            // delete tab from user portal
                            $.ajax({
                                url: '/api/tabs/delete-tab',
                                data: { tab_id: tab_id },
                                type: 'DELETE',
                                dataType: 'json',
                                cache: false,
                                async: true
                            })
                              .done(function (response) {
                                  bootbox.hideAll() // hide bootbox model
                                  // tab deleted successfully
                                  $app.gen.commonDoneResponseMessage(response)
                                  // get the delete tabid
                                  let tab_id = _.has(response, 'tab_id') ? response.tab_id : null
                                  if (tab_id) {
                                      $app._tab = _.omit($app._tab, [tab_id]) // remove tab from the list of tabs object
                                      $app._gen.tab_order = _.pull($app._gen.tab_order, _.parseInt(tab_id)) // remove tab from tab_order array
                                      if ($app._user.active_tab == tab_id) {
                                          tab_id = _.head($app._gen.tab_order) // if deleted tab same as current tab then display first tab
                                      } else {
                                          tab_id = $app._user.active_tab // else show the currently selected tab
                                      }
                                      // redirect to new tab
                                      $app.tab.redirect(tab_id)
                                  }
                              })
                              .fail(function (jqXHR, textStatus, errorThrown) {
                                  $app.gen.buttonLoading('btn-submit', false, successLabel) // hide loading on button
                                  $app.gen.commonFailResponseMessage(jqXHR)
                              })

                            // keep modal open
                            return false
                        }
                    }
                },
                onShown: function (e) {
                    $app.jq.bootstrapSelect()
                },
            })
        },

        /*
         * $app.setting.displaySubmitForm : Based on type (gadget/theme) display form
         * Params   : type - gadget/theme
         *          : tab_id - current tab id
         * Returns  : None
         */
        displaySubmitForm: function (type, tab_id) {
            if (tab_id !== __indef) {
                $app._user.active_tab = tab_id // set active tab
            }
            if (type == __GADGET) {
                if (__shindig_loaded) {
                    $app.shindig.init()  // initialise apache shindig
                }
                $app.gadget.displaySubmitForm()
            } else {
                $app.theme.displaySubmitForm()
            }
        }
    },

    /*------------------------------------------------------------------------------------------------*\
     * Class    :   $app.jq
     * Desc     :   Bind all jquery/jqueryUI events here
     \*-----------------------------------------------------------------------------------------------*/
    jq: {
        /*
         * $app.jq.init : bind all jquery/jquery ui events here
         * Params   : None
         * Returns  : None
         */
        init: function () {
            $app.jq.fireTooltips()
            $app.jq.firePopovers()
            $app.jq.bootstrapSelect()
            $app.jq.gadgetHeader()
            $app.jq.sortable()
            $app.jq.tabsSortable()
            $app.jq.editPref()
            $app.jq.hideShow()
            $app.jq.fullSmallScreen()
            $app.jq.deleteGadget()
            $app.jq.customStyle()
            $app.jq.refresh()
            $app.jq.preventFormSubmit()

            /*
             * removeClassPrefix : Remove Css Class With Prefix
             * Description: Remove classes that have given prefix. You have an element with classes
             *              "widget widget-color-red"
             * Params   : prefix
             * Returns  : Current objects after removing classes with prefix
             * Usage    : $elem.removeClassPrefix('widget-color-');
             */
            $.fn.removeClassPrefix = function (prefix) {
                this.each(function (i, it) {
                    let classes = it.className.split(' ')
                      .map(function (item) {
                          return item.indexOf(prefix) === 0 ? '' : item
                      })
                    it.className = $.trim(classes.join(' '))
                })
                return this
            }
        },

        /*
         * $app.jq.fireTooltips : Fire tooltips on page
         * Params   : None
         * Returns  : None
         */
        fireTooltips: function () {
            // Fire tooltips
            $('[rel=tooltip]').tooltip()
        },

        /*
         * $app.jq.firePopovers : Fire popovers on page
         * Params   : None
         * Returns  : None
         */
        firePopovers: function () {
            // Fire popover
            $('[data-toggle="popover"]').popover({
                trigger: 'hover',
                delay: { 'show': 0, 'hide': 1000 },
                placement: 'auto',
                html: true
            })
        },

        /*
         * $app.jq.bootstrapSelect : Initialize the bootstrap-select
         * Params   : None
         * Returns  : None
         */
        bootstrapSelect: function () {
            $('.selectpicker').selectpicker({
                size: 7,
                dropupAuto: false
            })
        },

        /*
         * $app.jq.gadgetHeader : Hide and display setting menus
         * Params   : None
         * Returns  : None
         */
        gadgetHeader: function () {
            // display setting menus when mouse hover on gadget header
            $('header').hover(function () {
                $(this).find('.jarviswidget-ctrls, .widget-toolbar').fadeTo(100, 1.0)
                $(this).children('div').css('display', 'inline-block')
            })

            // Hide setting menus when mouse hover on gadget body
            $('.widget-body').hover(function () {
                let $jarviswidget = $(this).closest('.jarviswidget')
                $jarviswidget.find('.jarviswidget-ctrls, .widget-toolbar').fadeTo(100, 0.0)
                $jarviswidget.find('header').children('div').css('display', 'none')
            })
        },

        /*
         * $app.jq.sortable : Jquery UI Sortable
         * Params   : None
         * Returns  : None
         */
        sortable: function () {
            // Jquery UI Sortable
            let sortItem = $('.sortable-grid')
            sortItem.sortable({
                items: sortItem.find('.jarviswidget-sortable'),
                connectWith: sortItem,
                placeholder: 'jarviswidget-placeholder',
                cursor: 'move',
                revert: true,
                opacity: 0.8,
                delay: 200,
                cancel: '.button-icon, #jarviswidget-fullscreen-mode > div',
                zIndex: 10000,
                handle: '> header',
                forcePlaceholderSize: true,
                forceHelperSize: true,
                helper: function (event, ui) {
                    let $clone = $(ui).clone()
                    $clone.css('position', 'absolute')
                    return $clone.get(0)
                },
                update: function (event, ui) {
                    if (this === ui.item.parent()[0]) {
                        $app.setting.saveGadgetPosition()
                    }
                }
            })
        },

        /*
         * $app.jq.tabsSortable : Change tabs order used in tabs option menu
         * Params   : None
         * Returns  : None
         */
        tabsSortable: function () {
            $('.tab-list').sortable({
                handle: '.tab-handle',
                forcePlaceholderSize: true,
                zIndex: 999999,
                update: function (event, ui) {
                    let positionArr = []
                    $('.tab-list li').each(function () {
                        let new_order = $(this).attr('id')
                        positionArr.push(new_order)
                    })
                    // Save new tab orders
                    $app.tab.saveTabOrder(positionArr)
                }
            }).disableSelection()
        },

        /*
         * $app.jq.editPref : Setting button - edit gadget preferences.
         * Params   : None
         * Returns  : None
         */
        editPref: function () {
            // Setting button - edit gadget preferences.
            let editWidgetPref = $('.jarviswidget-edit-btn')
            editWidgetPref.unbind('click')
            editWidgetPref.bind('click', function (e) {
                let pWidget = $(this).parents('.jarviswidget')
                let id = pWidget.attr('id').split('-')
                let key = id[2] + '-' + id[3]

                if ($app._gadget[key].type == __TYPE_FEED) {
                    // display feed gadget preferences for edit [different than shindig gadgets]
                    $app.feed.editSetting(key, __HOME)
                } else {
                    // display gadget user preferences for edit
                    $app.shindig.loadGadget(key, __HOME, __GADGET_EDIT_PREF)
                }
                e.preventDefault()
            })
        },

        /*
         * $app.jq.hideShow : Hide or Show widget content
         * Params   : None
         * Returns  : None
         */
        hideShow: function () {
            // Hide or Show widget content
            let hideShowWidget = $('.jarviswidget-toggle-btn')
            hideShowWidget.unbind('click')
            hideShowWidget.bind('click', function (e) {
                let tWidget = $(this)
                let pWidget = tWidget.parents('.jarviswidget')
                let id = pWidget.attr('id').split('-')
                let uniq_id = id[3]

                if (pWidget.hasClass('jarviswidget-collapsed')) {
                    tWidget.children()
                      .removeClass('fa fa-plus')
                      .addClass('fa fa-minus')
                      .parents('.jarviswidget')
                      .removeClass('jarviswidget-collapsed')
                      .children('[role=content]')
                      .slideDown(200, function () {
                          $app.setting.hideShow(uniq_id, 0) // show
                      })
                } else {
                    tWidget.children()
                      .removeClass('fa fa-minus')
                      .addClass('fa fa-plus')
                      .parents('.jarviswidget')
                      .addClass('jarviswidget-collapsed')
                      .children('[role=content]')
                      .slideUp(200, function () {
                          $app.setting.hideShow(uniq_id, 1) // hide
                      })
                }
                e.preventDefault()
            })
        },

        /*
         * $app.jq.fullSmallScreen : Fullscreen and Smallscreen Toggle
         * Params   : None
         * Returns  : None
         */
        fullSmallScreen: function () {
            // Fullscreen and Smallscreen Toggle
            let fullscreenWidget = $('.jarviswidget-fullscreen-btn')
            fullscreenWidget.unbind('click')
            fullscreenWidget.bind('click', function (e) {
                let thisWidget = $(this).parents('.jarviswidget')
                let thisWidgetContent = thisWidget.children('div')
                let id = thisWidget.attr('id').split('-')
                let key = id[2] + '-' + id[3]

                // Wrap the widget and go fullsize.
                if ($('#jarviswidget-fullscreen-mode').length) {
                    // Remove class from the body.
                    $('.nooverflow').removeClass('nooverflow')

                    // Unwrap the widget, remove the height, set the right
                    // fullscreen button back, and show all other buttons.
                    thisWidget.unwrap('div')
                      .children('div')
                      .removeAttr('style')
                      .end()
                      .find('.jarviswidget-fullscreen-btn')
                      .tooltip('hide')
                      .children()
                      .removeClass('fa fa-compress')
                      .addClass('fa fa-expand')
                      .parents('.jarviswidget-ctrls')
                      .children('a, #gadgetOptions')
                      .show()

                    // Reset collapsed widgets.
                    if (thisWidgetContent.hasClass('jarviswidget-visible')) {
                        thisWidgetContent.hide().removeClass('jarviswidget-visible')
                    }
                    // reload the contents based on view
                    $app.gadget.loadContent(key, __HOME)
                } else {
                    // Prevent the body from scrolling.
                    $('body').addClass('nooverflow')

                    // Wrap, append it to the body, show the right button
                    // and hide all other buttons.
                    thisWidget.wrap('<div id="jarviswidget-fullscreen-mode"/>')
                      .parent()
                      .find('.jarviswidget-fullscreen-btn')
                      .tooltip('hide')
                      .children()
                      .removeClass('fa fa-expand')
                      .addClass('fa fa-compress')
                      .parents('.jarviswidget-ctrls')
                      .children('a:not(.jarviswidget-fullscreen-btn), #gadgetOptions')
                      .hide()

                    // Show collapsed widgets.
                    if (thisWidgetContent.is(':hidden')) {
                        thisWidgetContent.show()
                          .addClass('jarviswidget-visible')
                    }
                    // Display Loading
                    let gadget_id = '#wid-id-' + key
                    let l_s = '<p class="text-center mt-2"><img src="' + $app._gen.gadgetLoading + '" alt="Loading..."></p>'
                    $(gadget_id).find('.widget-body').empty().append(l_s)
                    // reload the contents based on view
                    $app.gadget.loadContent(key, __CANVAS)
                }
                // Run the set height function.
                $app.gen.heightFullscreen()
                e.preventDefault()
            })
        },

        /*
         * $app.jq.deleteGadget : Allow users to delete the widgets
         * Params   : None
         * Returns  : None
         */
        deleteGadget: function () {
            //Allow users to delete the widgets.
            let deleteWidget = $('.jarviswidget-delete-btn')
            deleteWidget.unbind('click')
            deleteWidget.bind('click', function (e) {
                let tWidget = $(this).parents('.jarviswidget')
                let removeId = tWidget.attr('id')
                let widTitle = tWidget.children('header')
                  .children('h2')
                  .text()
                let id = removeId.split('-')
                let key = id[2] + '-' + id[3]
                let uniq_id = id[3]

                // Delete the widgets with a confirm popup.
                bootbox.dialog({
                    title: 'Are You Sure?',
                    message: 'Are you sure you want to remove gadget: <strong><i>' + widTitle + '</i></strong>',
                    buttons: {
                        cancel: {
                            label: '<i class="fas fa-arrow-left mr-2"></i>Cancel',
                            className: 'btn-sm btn-light font-family-nunito font-weight-bold',
                        },
                        danger: {
                            label: '<i class="fas fa-trash-alt mr-2"></i>Yes, remove it!',
                            className: 'btn-sm btn-danger font-family-nunito font-weight-bold',
                            callback: function () {
                                // Delete the right widget.
                                $('#' + removeId).fadeOut(200, function () {
                                    $(this).remove()
                                    // Run the callback function.
                                    $app.setting.removeModule(uniq_id, $app._gadget[key].posx)
                                })
                            }
                        }
                    }

                })

                e.preventDefault()
            })
        },

        /*
         * $app.jq.customStyle : Set a custom style.
         * Params   : None
         * Returns  : None
         */
        customStyle: function () {
            // Set a custom style.
            let widgetSetstyle = $('[data-widget-setstyle]')
            widgetSetstyle.unbind('click')
            widgetSetstyle.bind('click', function (e) {
                let tWidgetID = $(this).parents('.jarviswidget').attr('id')
                let id = tWidgetID.split('-')
                let uniq_id = id[3]
                let val = $(this).data('widget-setstyle')
                let style = ''
                if (val != '') {
                    let id = val.split('-')
                    style = id[2]
                }

                // Set the new style.
                $(this).parents('.jarviswidget')
                  .attr('data-widget-attstyle', '' + val + '')
                  .removeClassPrefix('jarviswidget-color-')
                  .addClass(val)

                // Run the callback function.
                $app.setting.saveModuleStyle(uniq_id, style)
                e.preventDefault()
            })
        },

        /*
         * $app.jq.deleteGadget : on refresh button click refresh widget contents
         * Params   : None
         * Returns  : None
         */
        refresh: function () {
            //on refresh button click refresh widget contents
            $('.jarviswidget-refresh-btn').unbind('click')
            $('.jarviswidget-refresh-btn').bind('click', function (e) {
                let widgetId = $(this).parents('.jarviswidget').attr('id')
                let id = widgetId.split('-')
                let key = id[2] + '-' + id[3]
                // Refresh only selected module
                $app.gadget.loadContent(key)
                e.preventDefault()
            })
        },

        /*
         * $app.jq.preventFormSubmit : Prevent form being submitted on enter key
         * Params   : None
         * Returns  : None
         */
        preventFormSubmit: function () {
            $(window).keydown(function (event) {
                if (event.keyCode == 13) {
                    event.preventDefault()
                    return false
                }
            })
        },

        /*
         * $app.jq.checkFormDataChange : Check if form data is changed or not, if changed then enable save/submit button otherwise disable it.
         * Params   : formId - Form CSS id
         *          : buttonId - Button CSS id to disable
         * Returns  : None
         */
        checkFormDataChange: function (formId, buttonId) {
            $('#' + formId + '').each(function () {
                $(this).data('serialized', $(this).serialize())
            }).on('change input', function () {
                $(this).find('#' + buttonId + '').attr('disabled', $(this).serialize() == $(this).data('serialized'))
            }).find('#' + buttonId + '').attr('disabled', true)
        }
    },

    /*------------------------------------------------------------------------------------------------*\
     * Class    :   $app.gen
     * Desc     :   All other general functions goes here
     \*-----------------------------------------------------------------------------------------------*/

    gen: {

        /*
         * $app.gen.timeAgo : calculate delay between current user time and news time
         * Params   : date timestamp
         * Returns  : 32 minutes ago
         */
        timeAgo: function (timestamp) {
            try {
                let currentTime = moment.utc().format('YYYY-MM-DD HH:mm:ss') // get the current UTC time
                let postTime = moment(timestamp, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss') // get the post time
                // get the difference between postTime and currentTime in milliseconds
                return moment.duration(moment(postTime).diff(moment(currentTime))).humanize(true)
            } catch (err) {
                return timestamp
            }
        },

        /*
         * $app.gen.deserialise : deserialise object
         * Params   : object
         * Returns  : return null/parsed JSON/object
         */
        deserialise: function (object) {
            if (object == null || object == __indef) {
                return null
            }
            if (typeof object === 'string') {
                try {
                    return $.parseJSON(object)
                } catch (ex) {
                    return object
                }
            } else if (typeof object === 'object') {
                for (let property in object) {
                    if (typeof object[property] === 'string') {
                        object[property] = this.deserialise(object[property])
                    }
                }
                return object
            }
        },

        /*
         * $app.gen.serialise : serialise object
         * Params   : object
         * Returns  : return string/json stringify/null
         */
        serialise: function (object) {
            let objextType = typeof object

            if (objextType === 'string') {
                return object
            } else if (objextType === 'object' || objextType === 'boolean') {
                let str = JSON.stringify(object)
                return $app.gen.escapeSpecialChars(str)
            } else {
                return null
            }
        },

        /*
         * $app.gen.escapeSpecialChars : Escape special chars from json string
         * Params   : string - JSON stringify string / or normal string
         * Returns  : Escaped string
         */
        escapeSpecialChars: function (string) {
            return string.replace(/'/g, '')
        },

        /*
         * $app.gen.heightFullscreen : Adjust the height of gadget on full screen mode
         * Params   : None
         * Returns  : None
         */
        heightFullscreen: function () {
            let fullscreenMode = $('#jarviswidget-fullscreen-mode')
            if (fullscreenMode.length) {
                // Setting height variables.
                let heightWindow = $(window).height()
                let heightHeader = fullscreenMode.find('.jarviswidget')
                  .children('header')
                  .height()

                // Setting the height to the right widget.
                fullscreenMode.find('.jarviswidget')
                  .children('div')
                  .height(heightWindow - heightHeader - 15)
            }
        },

        /*
         * $app.gen.ishttp : Check if the URL contains 'http://' or 'https://'
         * Params   : URL to check
         * Returns  : true or false
         */
        ishttp: function (url) {
            return (url.substr(0, 7) == 'http://' || url.substr(0, 8) == 'https://')
        },

        /**
         * $app.gen.commonDoneResponseMessage : Display server response message
         * @param response
         */
        commonDoneResponseMessage: function (response) {
            let message = _.has(response, 'message') ? response.message : null
            if (message) {
                toastr['success'](message)
            }
        },

        /**
         * $app.gen.commonFailResponseMessage : Process fail response,
         * e.g. laravel validation error, other fail errors.
         * @param jqXHR
         */
        commonFailResponseMessage: function (jqXHR) {
            let status = _.has(jqXHR, 'status') ? jqXHR.status : null
            switch (status) {
                case __HTTP_VALIDATION_FAILED:
                    let errorResponse = _.has(jqXHR, 'responseText') ? $.parseJSON(jqXHR.responseText) : 'Validation failed, please try again.'
                    let errorsHtml = '<ul class="list-unstyled">'
                    if (_.has(errorResponse, 'errors')) {
                        $.each(errorResponse.errors, function (key, error) {
                            errorsHtml += '<li>' + error[0] + '</li>'
                        })
                    }

                    errorsHtml += '</ul>'
                    toastr['error'](errorsHtml)
                    break
                case __HTTP_BAD_REQUEST:
                    let errorMessage = _.has(jqXHR, 'responseText') ? $.parseJSON(jqXHR.responseText) : 'Bad request, please try again.'
                    if (_.isObject(errorMessage)) {
                        errorMessage = _.has(errorMessage, 'message') ? errorMessage.message : 'Bad request, please try again.'
                    }
                    toastr['error'](errorMessage)
                    break
                case __HTTP_UNAUTHORIZED:
                    let message = 'You are not logged in. Please login and try again'
                    toastr['error'](message)
                    break
                case __HTTP_TOKEN_MISMATCH:
                    let tokenMismatch = 'The page has expired due to inactivity. Please refresh the page and try again.'
                    toastr['error'](tokenMismatch)
                    break
                default:
                    $app.gen.commonError()
            }
        },

        /**
         * $app.gen.buttonLoading : Show bootbox model processing/loading/please wait when
         * ajax form is submitted
         * @param btnName - class name of the button ".btn-save"
         * @param isDisable - true : disable button, false : enable button
         * @param label - label to show on button
         */
        buttonLoading: function (btnName, isDisable, label) {
            let btnSave = $('.' + btnName)
            btnSave.prop('disabled', isDisable)
            if (isDisable) {
                let buttonLabel = label == __indef ? 'Please wait...' : label
                btnSave.html('<i class="fas fa-circle-notch fa-spin mr-2"></i>' + buttonLabel)
            } else {
                let buttonLabel = label == __indef ? 'Submit' : label
                btnSave.html(buttonLabel)
            }
        },

        /*
         * $app.gen.commonError : Display common error
         * Params   : None
         * Returns  : None
         */
        commonError: function () {
            toastr['error']('Oops! Something went wrong, please try again.')
        },

        /*
         * $app.gen.truncate : Truncate the string without cutting word
         * Params   : str - string to truncate
         *          : maxLength - Length of the string
         *          : suffix - suffix like "..."
         * Returns  : encoded string
         */
        truncate: function (str, maxLength, suffix) {
            if (str.length > maxLength) {
                let tstr = str.substring(0, maxLength + 1)
                tstr = tstr.substring(0, Math.min(tstr.length, tstr.lastIndexOf(' ')))
                tstr = tstr + suffix
                return tstr
            } else {
                return str
            }
        },

        /*
         * $app.gen.removeTags : $p.string.removeTags - remove tags from a string
         * Params     : string - String
         * Returns    : string without tags
         */
        removeTags: function (string) {
            return string.replace(/<\/?[^>]+(>|$)/g, '')
//            var string = string.replace(/<table[^>]*>/gi, ""); // Remove table Tags
//            string = string.replace(/<script[^>]*>/gi, ""); // Remove script Tags
//            string = string.replace(/<img[^>]*>/gi,"");  // Remove image tags
//            string = string.replace(/<br[^>]*>/gi, ""); // Remove Break Tags
//            string = string.replace(/<h[^>]*>/gi, ""); // Remove header Tags
//            string = string.replace(/<strong[^>]*>/gi, ""); // Remove strong Tags
//            string = string.replace(/<b[^>]*>/gi, ""); // Remove bold Tags
//            string = string.replace(/<font[^>]*>/gi, ""); // Remove font Tags
//            return string;
        },

        /*
         * $app.gen.checkEmail : Check email validity [valid email address entered]
         * Params     :  v_email - email address
         * Returns    :  true / false
         */
        checkEmail: function (v_email) {
            let l_ret = true
            let l_reg = /^[a-z0-9._-]+@[a-z0-9.-]{2,}[.][a-z]{2,6}$/i
            if (l_reg.exec(v_email) == null) {
                l_ret = false
            }
            return l_ret
        }
    },

    /*------------------------------------------------------------------------------------------------*\
     * Class    :   $app.Base64
     * Desc     :   Base64 encode functions
     \*-----------------------------------------------------------------------------------------------*/
    Base64: {
        // private property
        _keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
        /*
         * $app.Base64.encode : Encode a string in Base64
         * Params   : input - string to encode
         * Returns  : encoded string
         */
        encode: function (input) {
            if (input == '' || input == ':') {
                return ''
            }

            let output = ''
            let chr1, chr2, chr3, enc1, enc2, enc3, enc4
            let i = 0
            input = $app.Base64._utf8_encode(input)
            while (i < input.length) {
                chr1 = input.charCodeAt(i++)
                chr2 = input.charCodeAt(i++)
                chr3 = input.charCodeAt(i++)
                enc1 = chr1 >> 2
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4)
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6)
                enc4 = chr3 & 63
                if (isNaN(chr2)) {
                    enc3 = enc4 = 64
                } else if (isNaN(chr3)) {
                    enc4 = 64
                }
                output = output
                  + this._keyStr.charAt(enc1)
                  + this._keyStr.charAt(enc2)
                  + this._keyStr.charAt(enc3)
                  + this._keyStr.charAt(enc4)
            }
            return output
        },

        /*
         * $app.Base64._utf8_encode : Encode a string in utf8
         * Params   : input - string to encode
         * Returns  : encoded string
         */
        _utf8_encode: function (string) {
            string = string.replace(/ /g, '\n')
            let utftext = ''
            for (let n = 0; n < string.length; n++) {
                let c = string.charCodeAt(n)
                if (c < 128) {
                    utftext += String.fromCharCode(c)
                } else if ((c > 127) && (c < 2048)) {
                    utftext += String.fromCharCode((c >> 6) | 192)
                    utftext += String.fromCharCode((c & 63) | 128)
                } else {
                    utftext += String.fromCharCode((c >> 12) | 224)
                    utftext += String.fromCharCode(((c >> 6) & 63) | 128)
                    utftext += String.fromCharCode((c & 63) | 128)
                }
            }
            return utftext
        }
    },

    /*------------------------------------------------------------------------------------------------*\
     * Class    :   $app.user
     * Desc     :   User account details
     \*-----------------------------------------------------------------------------------------------*/
    user: {

        /**
         * $app.user.showAnnouncements
         * Show active announcements to logged in users
         */
        showAnnouncements: function () {
            if ($app._user.logged === false) {
                return
            }

            // Get all active announcements for logged in user
            $.ajax({
                url: '/api/announcements',
                type: 'GET',
                dataType: 'json',
                cache: false,
                async: true,
            })
              .done(function (response) {
                  let $announcements = $('#announcements')

                  if (response.data.length === 0) {
                      // there are no announcements to show
                  } else {
                      $.each(response.data, function (index, announcement) {
                          let id = _.has(announcement, 'id') ? _.parseInt(announcement.id) : null
                          let title = _.has(announcement, 'title') ? announcement.title : null
                          let description = _.has(announcement, 'description') ? announcement.description : null
                          // check if there is valid text then only show it
                          if (description !== null && _.trim(description) !== '') {
                              // @formatter:off
                                let l_s = '<div class="alert alert-info alert-dismissible fade show mb-2" role="alert">'
                                                + description
                                                + '<button type="button" onclick="$app.user.markAnnouncementAsRead(' + id + '); return false;" class="close" data-dismiss="alert" aria-label="close">'
                                                    + '<span aria-hidden="true" data-toggle="popover" data-content="Don\'t show this again.">&times;</span>'
                                                +'</button>'
                                        + '</div>'
                                // @formatter:on

                              $announcements.append(l_s)
                          }
                      })
                  }
              })
              .fail(function (jqXHR, textStatus, errorThrown) {

              })
        },

        /**
         * $app.user.markAnnouncementAsRead : Mark announcement as read so that it won't be displayed again
         * @param announcement_id
         */
        markAnnouncementAsRead: function (announcement_id) {
            // store user preferences in database if user is logged in
            if ($app._user.logged && announcement_id !== __indef) {
                // update open social gadget preferences
                $.ajax({
                    url: '/api/announcements/markasread',
                    data: { announcement_id: announcement_id },
                    type: 'POST',
                    dataType: 'json',
                    cache: false,
                    async: true
                })
                  .done(function (response) {
                      $app.gen.commonDoneResponseMessage(response)
                  })
                  .fail(function (jqXHR, textStatus, errorThrown) {
                      $app.gen.commonFailResponseMessage(jqXHR)
                  })
            }
        },

        /*
         * $app.user.contactUsForm : Contact us option for users
         * Params   : none
         * Returns  : none
         */
        contactUsForm: function () {
            if ($app._user.logged === false) {
                toastr['error']('Please login to your account to get in touch with us.')
                return
            }

            let successLabel = 'Send Message'
            // @formatter:off
            let l_s = '<div class="row">'
                      + '<div class="col-sm-10 offset-sm-1">'
                          + '<form method="post" id="formContactUs" action="" >'
                                    + '<div class="alert alert-info fade show" role="alert">Please fill out all fields correctly, all fields are Mandatory.</div>'
                                    + '<div class="form-group">'
                                        + '<label for="inputName">Name</label>'
                                        + '<input type="text" class="form-control" name="inputName" id="inputName" placeholder="Enter your name" required>'
                                    + '</div>'
                                    + '<div class="form-group">'
                                        + '<label for="inputSubject">Subject</label>'
                                        + '<input type="text" class="form-control" name="inputSubject" id="inputSubject" placeholder="Enter subject" required>'
                                    + '</div>'
                                    + '<div class="form-group">'
                                        + '<label for="inputYourEmail">Your Email</label>'
                                        + '<input type="email" class="form-control" name="inputYourEmail" id="inputYourEmail" placeholder="Enter your email address" required>'
                                    + '</div>'
                                    + '<div class="form-group">'
                                        + '<label for="inpuCategory">Category</label>'
                                        + '<select class="form-control selectpicker" data-container="body" id="inpuCategory" name="inpuCategory">'
                                            + '<option value="Feedback" selected>Feedback</option>'
                                            + '<option value="Bug">Report Bug</option>'
                                            + '<option value="Feature">Add new Feature</option>'
                                            + '<option value="Gadget">Add new Gadget</option>'
                                            + '<option value="Theme">Add new Theme</option>'
                                            + '<option value="Advertisement">Advertisement</option>'
                                            + '<option value="Billing">Billing</option>'
                                            + '<option value="Premium">Premium</option>'
                                            + '<option value="Delete my Account">Delete my Account</option>'
                                            + '<option value="Others">Others</option>'
                                        + '</select>'
                                    + '</div>'
                                    + '<div class="form-group">'
                                        + '<label for="inputDetail">More Details</label>'
                                        + '<textarea class="form-control" id="inputDetail" name="inputDetail" rows="5" placeholder="Enter more details" required=""></textarea>'
                                    + '</div>'
                            + '</form>'
                        + '</div>'
                    + '</div>';
            // @formatter:on

            // Display Form
            bootbox.dialog({
                title: 'Contact Us',
                message: l_s,
                buttons: {
                    danger: {
                        label: '<i class="fas fa-arrow-left mr-2"></i>Cancel',
                        className: 'btn-sm btn-light font-family-nunito font-weight-bold',
                    },
                    success: {
                        label: '<i class="fas fa-envelope mr-2"></i>' + successLabel,
                        className: 'btn-sm btn-success font-family-nunito font-weight-bold btn-submit',
                        callback: function () {
                            let $formContactUs = $('#formContactUs')
                            let name = $formContactUs.find('input#inputName').val()
                            let subject = $formContactUs.find('input#inputSubject').val()
                            let userEmail = $formContactUs.find('input#inputYourEmail').val()
                            let category = $formContactUs.find('select#inpuCategory option:selected').val()
                            let detail = $formContactUs.find('textarea#inputDetail').val()

                            if ($.trim(name) != '' && $.trim(subject) != '' && $.trim(detail) != '' && $app.gen.checkEmail(userEmail)) {
                                $app.gen.buttonLoading('btn-submit', true) // show loading on button
                                // Required details filled send email to contact email address
                                $.ajax({
                                    url: '/api/users/contactus',
                                    data: {
                                        name: name, subject: subject, user_email: userEmail,
                                        category: category, detail: detail
                                    },
                                    type: 'POST',
                                    dataType: 'json',
                                    cache: false,
                                    async: true
                                })
                                  .done(function (response) {
                                      $app.gen.buttonLoading('btn-submit', false, successLabel) // hide loading on button
                                      // hide bootbox model
                                      bootbox.hideAll()
                                      $app.gen.commonDoneResponseMessage(response)
                                  })
                                  .fail(function (jqXHR, textStatus, errorThrown) {
                                      $app.gen.buttonLoading('btn-submit', false, successLabel) // hide loading on button
                                      $app.gen.commonFailResponseMessage(jqXHR)
                                  })
                            } else {
                                // Display error message stating not filled all details
                                toastr['error']('Please fill out all fields correctly, all fields are Mandatory.')
                            }
                            // keep model open
                            return false
                        }
                    }
                },
                onShown: function (e) {
                    $app.jq.bootstrapSelect()
                },
            })
        }
    }
};

// export this module to make it available to others
module.exports = $app;

// jQuery  Document Load Options
$(document).ready(function () {
    let __ALERT_DELAY = 15999 // default time (milli seconds) for message disappear

    toastr.options = {
        'closeButton': false,
        'debug': false,
        'newestOnTop': true,
        'progressBar': true,
        'positionClass': 'toast-bottom-right',
        'preventDuplicates': true,
        'onclick': null,
        'showDuration': '500',
        'hideDuration': '1000',
        'timeOut': '5000',
        'extendedTimeOut': '1000',
        'showEasing': 'swing',
        'hideEasing': 'linear',
        'showMethod': 'fadeIn',
        'hideMethod': 'fadeOut'
    }

    /**
     * Set the avatar-modal form action URL
     */
    $(document).on('click', '[data-target="#avatar-modal"]', function () {
        var formAction = $(this).attr('data-action')
        $('form.avatar-form').attr('action', formAction)
    })

    /**
     * remove Alert after some time
     *
     * @param {type} alertDelay
     * @returns {undefined}
     */
    function removeAlert (alertDelay) {
        let delay = alertDelay === __indef ? __ALERT_DELAY : alertDelay

        // hide flash message after some time
        window.setTimeout(function () {
            $('#app-error').fadeTo(500, 0).slideUp(500, function () {
                $(this).remove()
            })
        }, delay)

        // window.scrollTo(0, document.body.scrollHeight);
    }

    // call alert function to hide alert message
    removeAlert()

    /**
     * Avoid Google Map submitting the form
     */
    $('#autocomplete').bind('keypress', function (e) {
        if (e.keyCode == 13) {
            return false
        }
    })

    /**
     * Set the avatar-modal form action URL
     */
    $(document).on('click', '[data-target="#avatar-modal"]', function () {
        var formAction = $(this).attr('data-action')
        $('form.avatar-form').attr('action', formAction)
    })

    /**
     * Navbar menu toggle
     */
    $('#navbar-menu-toggle').click(function () {
        $('#navbar-menu-open, #navbar-menu-close').toggleClass('hidden')
    })
})
